/* exported modalState, addIEsupport, addRecentDomain, agentsTableHeight, answerrulesFeatureCheck,
 attachValidation, authChange, beforeSend, bindAccordionSlide, buildAndSetAutoComplete, callToOwn,
 caseInsensitiveCompare, cdrScheduleChangeDomain, cdrScheduleChangeReseller, changeAudioSource,
 changeDispType, lookupCall, changeDownloadSource, changehidden, checkSession, cleanDevice,
 cleanDevicePrep, cleanId,
 clearAutoComplete, clearForm, clickToAddParticipant, clickToDial, complete, contactsResize,
 convertByMapping, convertDateFormat, dayOfWeekCheck, discParticipant, dynamicCoverPageOptions,
 dynamicDateField, dynamicField, enableAgentDelete, fixHelper, forceLogout,
 forceValidate, getCount, getDropdownDirection, getDuration, getFieldWidthClass, getJsDebug,
 getMMss, getSecDiff, getTrace, greetingAddEditClose, greetingFade, cleanTermQueue, NetsapiensVoice,
 greetingFadeCallback, greetingsTableHeight, handleMsgCount, handleMsgCountChatSMS,
 handleMsgCountChatVM, hideAddEdit, hideAgentEdit, hideAgentModal, modalResize, hideModal,
 hideModalIf, hideModalIfNoReload, hqAgentOffnet, initContent, initDownloadFile, initFlashMessage,
 initTooltips,
 introsAddEdit, introsAddEditClose, inventoryChangeDomain, inventoryMacDomainChange, isNumber,
 jsFlash, launchWebPhone, loadModal, loadNextModal, log, cleanRemote,
 minimizeDockPopup, minusOneVmail, modifyDialPlanning, modifyDialPlanForDomain,
 muteParticipant, newDatePicker, newPassValidate, onConfirm, openContactsPopoutWindow, ownDevice,
 pad, phoneShowOptions, placeholderInit, postLog, postValue, printDiv, printFrame, printReport,
 progress, propagateTabTrace, radioSlide, releaseDevice, reloadModal, reloginWebphone,
 getContactList, removeRecentDomain, routeTypeChange, setDateValidation, setFaxUploadValidation,
 onBlurStatus, setJsDebug, showAgentEdit, showConfReport, showMoreTZoptions, showRecord,
 showUpload, start, toggleAgentEdit, toggleHiddenUser, toggleMoh0, trunkTypeChange,
 unmuteParticipant, update, updateExportHref, updateExportHrefShared, updateGreetingDD,
 updateRecentDomain, validateDateRange, BrowserDetect, getModalData, setModalData,
 brandingChangeDomain, brandingChangeDomainUser, selectLanguages, formatVoiceLabel,
 handleGreetingTimeFrameSelect, subscribeOnce, replaySubscriptions,
 selectVoices, filterContactList, toggleSiteManagerScope, updateModalPosition */
/* global subDomain, subUser, maxDays, portalWebPhoneNewTabView, findCheck, views, Storages,
 CallCenterReportGenerator, initSimDelayPopover, enableChatUC, enableChatSMS, subscriptions,
 NsAgentsMain, XDomainRequest, portalPhoneNumberRemovePoundPrefixes, openModalId:writable, subScope,
 portalPhoneNumberRemovePlusOnCall, initConfirmCall, portalPhoneNumberHideDomesticOne, notesClear,
 portalCallHistoryRecordingPreload, addressesJs, portalCradleToGraveFeatureName, preferMp4,
 currentServerName */

/** *****************************************************************************
 * global variables and options
 *******************************************************************************
 */

var cleanDeviceCache = {};

// The server holds subscriptions per connection, so a drop clears everything it
// had for us. This counter changes whenever the connection does, which is what
// lets a subscription still sitting in `subscriptions` be recognised as needing
// to be sent again.
var socketConnectionCount = 0;
var socketLifecycleBound = false;

// subscriptionKey(options) -> the connection token the payload was last
// successfully emitted on.
var emittedConnections = Object.create(null);

// A replay goes out in small batches instead of one burst. Each subscribe makes
// the server send a snapshot of the feed, and on a large domain replaying every
// feed at once is enough of those to bury the main thread.
var REPLAY_BATCH_SIZE = 5;
var REPLAY_BATCH_DELAY_MS = 250;

// How long a replay waits for a refreshed access token before falling back to
// the stored one.
var TOKEN_REFRESH_TIMEOUT_MS = 5000;

/**
 * Build a stable identity for a socket subscription request.
 *
 * @param {object} options is the payload passed to socket.emit('subscribe')
 * @returns {string} key identifying the feed the payload asks for
 */
function subscriptionKey(options) {
  return [
    options.type,
    options.subtype,
    options.domain,
    options.filter,
    options.user,
    options.bridge,
  ].join('|');
}

/**
 * Identify the connection subscriptions currently live on. socket.id is reissued
 * on every reconnect; the counter also covers the window after a disconnect,
 * before a new id has been assigned.
 *
 * @returns {string} token identifying the current connection
 */
function connectionToken() {
  return socketConnectionCount + ':' + (typeof socket === 'undefined' ? '' : socket.id);
}

/**
 * Watch for connection loss, so subscriptions can be re-sent afterwards. Bound
 * lazily: the socket is created by the layout, after this file has loaded.
 */
function bindSocketLifecycleHandlers() {
  if (socketLifecycleBound || typeof socket === 'undefined') {
    return;
  }

  socketLifecycleBound = true;

  socket.on('disconnect', function () {
    socketConnectionCount += 1;
  });

  // emitSubscribe() holds back anything registered before the socket finished
  // connecting, so send it now. Feeds this connection already carries are
  // skipped.
  socket.on('connect', function () {
    // eslint-disable-next-line no-use-before-define
    replaySubscriptions();
  });
}

/**
 * Emit a subscribe for a payload, if this connection both needs it and can
 * carry it.
 *
 * @param {object} options is the payload to subscribe with
 * @returns {boolean} true when the subscribe was handed to the socket
 */
function emitSubscribe(options) {
  // A closing or closed socket discards the frame - socket.io logs 'WebSocket is
  // already in CLOSING or CLOSED state' and carries on - so emitting regardless
  // would record a subscription the server never received.
  if (typeof socket === 'undefined' || !socket.connected) {
    return false;
  }

  var key = subscriptionKey(options);

  // This connection already carries the feed. Both the layout's 'connect'
  // handler and the reconnect replay reach here for the same subscription.
  if (emittedConnections[key] === connectionToken()) {
    return false;
  }

  socket.emit('subscribe', options);
  emittedConnections[key] = connectionToken();

  return true;
}

/**
 * Subscribe to a socket feed, without asking one connection for it twice.
 *
 * The layout's socket 'connect' handler fires again on every reconnect and
 * re-invokes the sGet*Data() functions. Those used to push onto `subscriptions`
 * and emit 'subscribe' unconditionally, so the array grew without bound and the
 * server delivered one copy of every event per duplicate subscription. On a
 * large domain that multiplied the presence traffic until the main thread
 * couldn't keep up - the portal got progressively slower the longer a session
 * stayed open, then locked up.
 *
 * Note that this deduplicates per connection rather than per page. `subscriptions`
 * outlives any one connection, but the server's view of it does not: after a
 * reconnect the feed genuinely has to be requested again, and treating the entry
 * as proof of an existing subscription is what left the portal believing it was
 * subscribed to feeds the server was no longer sending.
 *
 * @param {object} options is the payload to subscribe with
 */
function subscribeOnce(options) {
  if (typeof socket === 'undefined' || typeof subscriptions === 'undefined') {
    return;
  }

  bindSocketLifecycleHandlers();

  var key = subscriptionKey(options);
  var existing = null;

  subscriptions.forEach(function (subscription) {
    if (!existing && subscriptionKey(subscription) === key) {
      existing = subscription;
    }
  });

  if (!existing) {
    subscriptions.push(options);
    emitSubscribe(options);

    return;
  }

  // Already registered. Refresh the token in case it rotated, then let
  // emitSubscribe() decide whether this connection still needs the feed.
  existing.bearer = options.bearer;

  emitSubscribe(existing);
}

/**
 * Emit one batch of subscribes, then schedule the next.
 *
 * @param {Array} pending is the list of payloads to re-subscribe with
 * @param {number} start is the index to resume from
 * @param {string} token identifies the connection the replay was started for
 */
function replayBatch(pending, start, token) {
  // The connection this replay was for has gone. Anything still unsent belongs
  // to the next one, which runs a replay of its own.
  if (token !== connectionToken()) {
    return;
  }

  var end = Math.min(start + REPLAY_BATCH_SIZE, pending.length);
  var i;

  for (i = start; i < end; i += 1) {
    emitSubscribe(pending[i]);
  }

  if (end >= pending.length) {
    return;
  }

  setTimeout(function () {
    replayBatch(pending, end, token);
  }, REPLAY_BATCH_DELAY_MS);
}

/**
 * Resolve the bearer for a replay. After a long outage the stored token has
 * most likely expired, and the server ignores a subscribe that carries one.
 *
 * netsapiens.api.getAccessToken() fetches a new token once the stored one is
 * within a minute of expiring. It never rejects: a failed fetch leaves its
 * promise pending, so the wait is capped and falls back to the stored token.
 *
 * @returns {Promise<string|undefined>} the bearer to subscribe with
 */
function replayBearer() {
  return new Promise(function (resolve) {
    var timer = setTimeout(function () {
      resolve(window.localStorage.access_token);
    }, TOKEN_REFRESH_TIMEOUT_MS);

    netsapiens.api.getAccessToken().then(function (accessToken) {
      clearTimeout(timer);
      resolve(accessToken);
    });
  });
}

/**
 * Re-establish every subscription after a reconnect. A reconnect gives us a new
 * connection with no subscriptions server-side, so all of them have to be sent
 * again - but from the deduplicated list, not by re-running the sGet*Data()
 * functions.
 */
function replaySubscriptions() {
  if (typeof socket === 'undefined' || typeof subscriptions === 'undefined') {
    return;
  }

  bindSocketLifecycleHandlers();

  // The bearer resolves asynchronously, by which point this connection may have
  // been replaced. The replacement runs a replay of its own.
  var token = connectionToken();

  replayBearer().then(function (bearer) {
    if (token !== connectionToken()) {
      return;
    }

    if (bearer) {
      subscriptions.forEach(function (options) {
        options.bearer = bearer;
      });
    }

    // Work from a copy: a subscribe raised while the replay is still batching
    // appends to `subscriptions` and emits itself, so it must not be replayed too.
    replayBatch(subscriptions.slice(), 0, token);
  });
}

// strip all characters except numbers
function cleanDevicePrep(str) {
  if (str == null) {
    return '';
  }

  // make sure str is a string
  if (typeof str !== 'string') {
    str = str.toString();
  }

  str = str.replace('sip', '');
  str = str.replace(':', '');

  if (portalPhoneNumberRemovePlusOnCall) {
    str = str.replace('+', '');
  }

  str = str.replace('(', '');
  str = str.replace(')', '');
  str = str.replace('-', '');
  str = str.replace(/\./g, '');
  str = str.replace(/:/g, '');
  str = str.replace(/ /g, '');

  if (portalPhoneNumberRemovePlusOnCall) {
    str = str.replace(/\+/g, '');
  }

  str = str.replace(/\(/g, '');
  str = str.replace(/\)/g, '');
  str = str.replace(/-/g, '');
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.replace('wp', '');
  str = str.replace('"', '');
  str = str.replace(']', '');
  str = str.replace('[', '');

  var group = str.split('@');

  str = group[0];
  str = str.replace('%40', '@');

  group = str.split('@');

  str = group[0];

  return str;
}

// returns a formatted NA number
function cleanDevice(str) {
  if (cleanDeviceCache[str] != null) {
    return cleanDeviceCache[str];
  }

  var found = false;
  var formattedNumber = str;

  $('.hiddenconflist').each(function () {
    if ($(this).attr('id') == formattedNumber) {
      found = true;
      formattedNumber = $(this).val();

      return false;
    }

    return true;
  });

  if (found) {
    cleanDeviceCache[str] = formattedNumber;

    return cleanDeviceCache[str];
  }

  if (typeof formattedNumber !== 'string') {
    formattedNumber += '';
  }

  if (portalPhoneNumberRemovePoundPrefixes) {
    formattedNumber = formattedNumber.replace('%23', '#');
    formattedNumber = formattedNumber.substring(formattedNumber.indexOf('#') + 1);
  }

  if (formattedNumber == 'Call-To-Talk') {
    cleanDeviceCache[str] = _('Click to Call');

    return cleanDeviceCache[str];
  }

  formattedNumber = cleanDevicePrep(formattedNumber);

  if (formattedNumber.includes('video.bridge')) {
    formattedNumber = _('Video Bridge');
  }

  if (/^\d+$/.test(formattedNumber)) {
    if (formattedNumber.length === 11 && formattedNumber[0] == '1') {
      formattedNumber = '(' + formattedNumber.substring(1, 4) + ') ' + formattedNumber.substring(4, 7) + '-' + formattedNumber.substring(7, 11);

      formattedNumber = portalPhoneNumberHideDomesticOne
        ? formattedNumber
        : '1 ' + formattedNumber;
    } else if (formattedNumber.length === 10 && formattedNumber[0] != '0' && formattedNumber[0] != '1') {
      formattedNumber = '(' + formattedNumber.substring(0, 3) + ') ' + formattedNumber.substring(3, 6) + '-' + formattedNumber.substring(6, 10);
    } else if (formattedNumber.length === 7) {
      formattedNumber = formattedNumber.substring(0, 3) + '-' + formattedNumber.substring(3, 7);
    }
  }

  cleanDeviceCache[str] = formattedNumber;

  return cleanDeviceCache[str];
}

/**
 * Case-insensitive string comparison for sorting
 *
 * @param {string} a - First string to compare
 * @param {string} b - Second string to compare
 * @returns {number} -1 if a < b, 1 if a > b, 0 if equal
 */
function caseInsensitiveCompare(a, b) {
  var aClean = a == null ? '' : a;
  var bClean = b == null ? '' : b;
  var aLower = aClean.toLowerCase();
  var bLower = bClean.toLowerCase();

  if (aLower < bLower) {
    return -1;
  }

  return aLower > bLower ? 1 : 0;
}

// Defines String.format to behave similar to php's sprintf()
// Used for localization string substitution purposes
// Ex. String.format('{0} is dead, but {1} is alive! {0} {2}', 'ASP', 'ASP.NET'); => ASP is dead,
// but ASP.NET is alive! ASP {2}
// This function may not be necessary. the translate function _ appears to already do this
if (!String.format) {
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1);

    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined'
        ? args[number]
        : match;
    });
  };
}

if (!String.prototype.includes) {
  // eslint-disable-next-line no-extend-native
  String.prototype.includes = function (search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    }

    return this.indexOf(search, start) !== -1;
  };
}

if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-extend-native
  String.prototype.startsWith = function (searchString, position) {
    return this.substr(position || 0, searchString.length) === searchString;
  };
}

if (!String.prototype.trim) {
  // eslint-disable-next-line no-extend-native
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

if (!String.prototype.isNumber) {
  // eslint-disable-next-line no-extend-native
  String.prototype.isNumber = function () {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(parseFloat(this)) && isFinite(this);
  };
}

// Converts from moment.js format to datepicker format
// keys need to be arranged in order of greatest number of characters to least ex. 'ddd' before 'dd'
var datepickerConversionFormats = {
  Day: {
    Do: 'd',
    DD: 'dd',
    D: 'd',
    dddd: 'DD',
    ddd: 'D',
  },
  Month: {
    MMMM: 'MM',
    MMM: 'M',
    MM: 'mm',
    M: 'm',
  },
  Year: {
    YYYY: 'yy',
    YY: 'y',
  },
  Abbrev: {
    A: 'tt',
    a: 'tt',
  },
};
// global var for referencing contacts popout window
var contactsPopoutWindow;
// global var for tracking current state of the modal
var modalState = 'closed';
var modalTimer;
/**
 * Re-focus webphone tab/window
 *
 * @param {string} number passed from portal
 */
var webphoneTab;
var webphoneWindow;

// ping webphone

if (typeof subUser !== 'undefined') {
  localStorage.setItem('webphone_present_' + subUser, null);
}

// webphone backwards compatibility
localStorage.setItem('webphone_present', null);

if (typeof subUser !== 'undefined') {
  localStorage.removeItem('webphone_present_' + subUser);
}

// webphone backwards compatibility
localStorage.removeItem('webphone_present');

// global scrollTop cursor, used for smoothed modal behavior
var scrollTop;

function log(msg, force) {
  if (window.jsdebug
    && typeof console !== 'undefined'
    && typeof console.log === 'function'
    && typeof msg !== 'undefined'
  ) {
    console.log(msg);
  } else if (typeof force !== 'undefined' && force === true && typeof msg !== 'undefined') {
    console.log(msg);
  }

  if (window.jstrace) {
    console.trace();
  }
}

/**
 * Turns log() debug on and off.
 *
 * @param {boolean} setting turns on or off the log
 * @param {boolean} trace turn on or off trace data in the log
 *
 */
function setJsDebug(setting, trace) {
  var storage = Storages.localStorage;

  storage.set('jsDebugSetting', setting);

  window.jsdebug = setting;

  if (typeof trace !== 'undefined') {
    storage.set('jsTraceSetting', trace);
    window.jstrace = trace;
  }
}

function getJsDebug() {
  var storage = Storages.localStorage;
  var setting = false;

  if (storage.isSet('jsDebugSetting')) {
    setting = storage.get('jsDebugSetting');
  }

  if (storage.isSet('jsTraceSetting')) {
    window.jstrace = storage.get('jsTraceSetting');
  } else {
    window.jstrace = false;
  }

  return setting;
}

function jsFlash(html, theClass, duration, callback) {
  var $flashMessage = $('.flashMessage');
  var count = $flashMessage.length;
  var displayDuration = typeof duration === 'number' ? duration : 6000;
  var message = $('<div></div>');

  if (theClass == null) {
    theClass = 'info';
  }

  message.addClass([
    'flashMessage',
    'new',
    'alert-dismissible',
    'alert',
    'alert-' + theClass,
  ]);
  message.html(html.toString());

  if (arguments.length > 0) {
    $('#flashContainer').append(message);
    $('.message-container').css('visibility', 'visible');

    message.hide().animate(
      {
        height: 'show',
        opacity: 'show',
      },
      200,
      function () {
        $('.message-container').css('visibility', 'hidden');
      },
    );

    if (count > 2) {
      $flashMessage.first().fadeOut(100, function () {
        $(this).remove();
      });
    }
  }

  setTimeout(function () {
    // You can modify this to display the message for different times
    message.fadeOut(500, function () {
      $(this).remove();
    });
  }, displayDuration);

  // Make the messages container clickable to hide the message before the timeout fires
  message.on('click', function () {
    $(this).fadeOut(500, function () {
      $(this).remove();
    });
  });

  if (typeof callback === 'function') {
    callback();
  } else {
    $flashMessage.removeClass('new');
  }
}

// Auto-dismiss server-rendered flash messages on page load
$(function () {
  $('.flashMessage').each(function () {
    var $message = $(this);
    var duration = parseInt($message.data('duration'), 10) || 6000;

    // Set up click-to-dismiss
    $message.on('click', function () {
      $(this).fadeOut(500, function () {
        $(this).remove();
      });
    });

    // Auto-dismiss after specified duration
    setTimeout(function () {
      $message.fadeOut(500, function () {
        $(this).remove();
      });
    }, duration);
  });
});

if (typeof jsdebug === 'undefined') {
  window.jsdebug = getJsDebug();
}

if (typeof openModalId === 'undefined') {
  window.openModalId = null;
}

$.xhrPool = [];

$.xhrPool.abortAll = function () {
  var countAbort = 0;

  $(this).each(function (idx, jqXHR) {
    countAbort += 1;
    jqXHR.abort();
  });

  if (countAbort) {
    log('Aborted ' + countAbort + ' ajax requests');
  }

  $.xhrPool = [];
};

$.ajaxSetup({
  beforeSend: function (jqXHR) {
    $.xhrPool.push(jqXHR);
  },
  complete: function (jqXHR) {
    var index = $.inArray(jqXHR, $.xhrPool);

    if (index > -1) {
      $.xhrPool.splice(index, 1);
    }
  },
});

// custom file input display field
$(document).on(
  'click',
  '.form-group.file-upload .file-location, .form-group.file-upload .browse-btn',
  function () {
    var $self = $(this);

    $self
      .closest('.form-group.file-upload')
      .find('input:file')
      .trigger('click');
  },
);

log('adding file location field listener');
$(document).on('change', '.form-group.file-upload input:file', function () {
  var $self = $(this);
  var fileLocation = this.files[0].name;

  $self.closest('.form-group')
    .find('input.file-location')
    .val(fileLocation);
});

/** *****************************************************************************
 * Custom functions
 *******************************************************************************
 */

function placeholderInit(input) {
  if (!$.support.placeholder) {
    $(input)
      .on('focus', function () {
        if ($(this).attr('placeholder') != '' && $(this).val() == $(this).attr('placeholder')) {
          $(this).val('')
            .removeClass('hasPlaceholder');
        }
      })
      .on('blur', function () {
        if ($(this).attr('placeholder') != ''
          && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder'))
        ) {
          $(this).val($(this).attr('placeholder'))
            .addClass('hasPlaceholder');
        }
      });

    $(input).trigger('blur');
  }
}

function buildAndSetAutoComplete(type, source, input, exclusions, value, isFuzzyMatch) {
  if (typeof isFuzzyMatch === 'undefined') {
    isFuzzyMatch = false;
  }

  var choices = $('#' + source + ' option').map(function () {
    if (exclusions == null) {
      return this.value;
    }

    if (!exclusions.includes(this.value)) {
      return this.value;
    }

    return null;
  });

  if (value != null) {
    var autocompleteChoices = $('#' + source + ' option').filter(function () {
      if (isFuzzyMatch && this.dataset.cleaned.startsWith(value)) {
        return true;
      }

      return this.dataset.cleaned == value;
    });

    if (typeof autocompleteChoices !== 'undefined' && autocompleteChoices.length === 1 && autocompleteChoices[0].value) {
      input.val(autocompleteChoices[0].value);
    }
  }

  input.autocomplete({
    minLength: 0,
    source: function (request, response) {
      var results = $.ui.autocomplete.filter(choices, request.term);

      if (!results.length) {
        // Only show error if input still has focus
        if (input.is(':focus')) {
          input.validationEngine(
            'showPrompt',
            '* ' + _('No Matches Found') + '!',
            'red',
            'bottomLeft',
            true
          );
        }
      } else {
        input.validationEngine('hide');
      }

      response(results);
    },

    select: function (event, ui) {
      var selectedObj = ui.item;

      event = new CustomEvent('autocomplete-select', {
        detail: {
          event: event,
          selectedObj: selectedObj,
        },
      });

      window.dispatchEvent(event);
    },

    close: function () {
      input.validationEngine('hide');

      // Also directly remove formError div as fallback
      var inputId = input.attr('id');
      var formError = document.querySelector('.' + inputId + 'formError');

      if (formError) {
        formError.remove();
      }
    },
  });

  input.on('blur', function () {
    // Hide via validationEngine
    input.validationEngine('hide');

    // Also directly remove formError div as fallback (same pattern used in BtnConfig.jsx)
    var inputId = input.attr('id');
    var formError = document.querySelector('.' + inputId + 'formError');

    if (formError) {
      formError.remove();
    }
  });
}

function getFieldWidthClass(element, maxSmall, maxMed) {
  var format = '';

  if (element.hasAttribute('data-date-format')) {
    format += element.getAttribute('data-date-format') + ' ';
  }

  if (element.hasAttribute('data-time-format')) {
    format += element.getAttribute('data-time-format');
  }

  if (format) {
    var formatWidths = {
      Year: {
        YYYY: 30,
        YY: 15,
      },
      Day: {
        Do: 25,
        DD: 15,
        D: 7,
        dddd: 65,
        ddd: 25,
      },
      Month: {
        MMMM: 65,
        MMM: 25,
        MM: 15,
        M: 7,
      },
      Hour: {
        HH: 15,
        H: 7,
        hh: 15,
        h: 7,
      },
      Minute: { mm: 15 },
      Second: { ss: 15 },
      Abbrev: {
        A: 20,
        a: 20,
      },
    };

    var width = 0;

    Object.keys(formatWidths).forEach(function (category) {
      $.each(formatWidths[category], function (formatType, formatWidth) {
        if (format.indexOf(formatType) != -1) {
          width += formatWidth;

          return false;
        }

        return true;
      });
    });

    if (width <= maxSmall) {
      return 'date-small';
    }

    if (width > maxSmall && width <= maxMed) {
      return 'date-medium';
    }

    if (width > maxMed) {
      return 'date-large';
    }
  }

  return null;
}

function launchWebPhone(nmbr) {
  // check local storage for webphpone + user
  var webphoneOpen = localStorage.getItem('webphone_open_' + subUser);

  if (!webphoneOpen || webphoneOpen == 'false') {
    var query = '?user=' + subUser;

    if (nmbr) {
      query += '&call=' + nmbr;
    }

    if (portalWebPhoneNewTabView) {
      // UI Config for new tab view ( set to yes )
      webphoneTab = window.open('/webphone' + query, 'webphone');
      webphoneTab.focus();
    } else {
      // Webphone Window view ( compact webphone )
      webphoneWindow = window.open(
        '/webphone' + query,
        'webphone',
        'directories=no,titlebar=no,location=no,status=no,menubar=no,resizable=no,width=400,height=640',
      );
    }
  } else if (nmbr) {
    // Portal call passing number to Webphone
    localStorage.setItem('webphone_call_' + subUser, nmbr);
    localStorage.removeItem('webphone_call_' + subUser);
    localStorage.setItem('webphone_call', nmbr);
    localStorage.removeItem('webphone_call');

    if (!webphoneWindow && !webphoneTab) {
      if (portalWebPhoneNewTabView) {
        webphoneTab = window.open('', 'webphone');

        if (webphoneTab) {
          webphoneTab.focus();
        }
      } else {
        // Webphone Window view ( compact webphone )
        webphoneWindow = window.open('', 'webphone');

        if (webphoneWindow) {
          webphoneWindow.focus();
        }
      }
    } else if (webphoneWindow && !webphoneTab) {
      // Webphone window is open
      webphoneWindow.focus();
    } else if (!webphoneWindow && webphoneTab) {
      // Webphone tab is open
      webphoneTab.focus();
    }
  } else if (!webphoneWindow && !webphoneTab) {
    // NO instance of tab/window found
    localStorage.removeItem('webphone_open_' + subUser);
    launchWebPhone();
  } else if (webphoneWindow && !webphoneTab) {
    // Webphone window is open
    webphoneWindow.focus();
  } else if (!webphoneWindow && webphoneTab) {
    // Webphone tab is open
    webphoneTab.focus();
  }
}

function reloginWebphone(nmbr) {
  $.ajax({ url: '/portal/webphone/relogin', timeout: 30000 }).done(function () {
    setTimeout(function () {
      launchWebPhone(nmbr);
    }, 400);
  }).fail(function () {
    log('Failed to relogin webphone');
  });
}

function getContactList(type) {
  // The dock renders its roster virtually - only visible rows exist in the
  // DOM - so the list must come from its data model. The DOM path below still
  // serves pages with server-rendered rows (contacts popout).
  if (typeof NSDockRoster !== 'undefined' && NSDockRoster.isActive()) {
    return NSDockRoster.getContactList(type);
  }

  var contactList = [];

  if (typeof type === 'undefined') {
    type = 'all';
  }

  $('#contacts-table tr.contact-row-info').each(function () {
    var c = {
      name: $(this)
        .find('.contact-name')
        .text(),
    };

    if (enableChatUC
      && (type == 'all'
        || type == 'chat'
        || type == 'chat-name-change'
        || type == 'chat-video-invite'
        || type == 'chat-participant-add'
        || type == 'chat-participant-remove'
        || type == 'chat-participant-leave')
    ) {
      c.extension = $(this)
        .find('.contact-extension')
        .text();

      if (typeof c.extension !== 'undefined' && c.extension !== '' && c.extension != c.name) {
        c.label = c.name + ' - Chat';
        c.imgclass = 'iconfont iconfont-comment';
        c.value = $(this)
          .find('.contact-extension')
          .html();
        c.text = c.label;
        c.id = c.value;

        // add the value/number to the id as well
        c.text += '(num)' + c.value;

        contactList.push(c);
      } else {
        delete c.extension;
      }
    }

    if (enableChatSMS && (type == 'all' || type == 'sms' || type == 'mms')) {
      $(this).find('.dropdown-menu li')
        .each(function () {
          if ($(this).data('smsnumber')) {
            var tmpType = $.extend(true, {}, c);

            tmpType.value = $(this).data('smsnumber');
            tmpType.number = $(this).data('smsnumber');

            if ($(this).hasClass('smsmobile')) {
              tmpType.label = c.name + ' - Mobile SMS';
              tmpType.imgclass = 'nsicon nsicon-mobile';
            } else if ($(this).hasClass('smshome')) {
              tmpType.label = c.name + ' - Home SMS';
              tmpType.imgclass = 'nsicon nsicon-home';
            } else if ($(this).hasClass('smswork')) {
              tmpType.label = c.name + ' - Work SMS';
              tmpType.imgclass = 'nsicon nsicon-work';
            }

            tmpType.text = tmpType.label + '(num)' + tmpType.value;
            tmpType.id = tmpType.label;

            contactList.push(tmpType);
          }
        });
    }
  });

  return contactList;
}

function filterContactList(allContacts, toFilterUid, toFilterName) {
  var filteredContacts = [];

  if (typeof toFilterUid === 'undefined' || typeof toFilterName === 'undefined') {
    return allContacts;
  }

  for (var index = 0; index < allContacts.length; index += 1) {
    if ((!allContacts[index].extension || !toFilterUid.includes(allContacts[index].extension))
      && (!allContacts[index].name || !toFilterName.includes(allContacts[index].name))
    ) {
      filteredContacts.push(allContacts[index]);
    }
  }

  return filteredContacts;
}

// open contacts popout or focus it if already open
// unique window name means we'll always use the same window
function openContactsPopoutWindow() {
  var url = '/portal/contacts/popout';
  var params = 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,resizable=no,width=275,height=600';

  if (typeof (contactsPopoutWindow) === 'undefined' || contactsPopoutWindow.closed) {
    // create new, since none is open
    contactsPopoutWindow = window.open(url, 'contacts_popout_window', params);
  } else {
    try {
      // if this throws an exception then we have no access to the child window - probably domain
      // change so we open a new window
      // eslint-disable-next-line no-unused-expressions
      contactsPopoutWindow.document;
    } catch (e) {
      contactsPopoutWindow = window.open(url, 'contacts_popout_window');
    }

    // focus the window if it already exists
    contactsPopoutWindow.focus();
  }
}

function convertByMapping(original, conversionUnits) {
  Object.keys(conversionUnits).forEach(function (key) {
    $.each(conversionUnits[key], function (baseUnit, conversionUnit) {
      // TODO SCASTRO please review.
      if (original != null && original.indexOf(baseUnit) != -1) {
        original = original.replace(baseUnit, conversionUnit);

        return false;
      }

      return true;
    });
  });

  return original;
}

// Converts standard js date format rules into a different set of format rules
// (this is necessary because jquery's datepicker uses its own date formatting logic
// with its own formatting rules)
function convertDateFormat(original, conversionUnits) {
  return convertByMapping(original, conversionUnits);
}

// Sets the proper date format for an input field's alert message in case of failed validation
// eslint-disable-next-line consistent-return
function setDateValidation(field, rules, i, options) {
  var dateInput = field[0];
  var dateFormat = '';

  if (dateInput.hasAttribute('data-date-format')) {
    dateFormat = dateInput.getAttribute('data-date-format');
  }

  var timeFormat = '';

  if (dateInput.hasAttribute('data-time-format')) {
    timeFormat = dateInput.getAttribute('data-time-format');
  }

  var dateAndTimeFormats = '';

  if (dateFormat && timeFormat) {
    dateAndTimeFormats = dateFormat + ' ' + timeFormat;
  } else if (dateFormat && !timeFormat) {
    dateAndTimeFormats = dateFormat;
  } else if (!dateFormat && timeFormat) {
    dateAndTimeFormats = timeFormat;
  }

  var inputDate = moment(field.val(), dateAndTimeFormats);

  if (!inputDate.isValid() && field.val() != '') {
    var customRule = rules.indexOf('custom');

    return String.format(options.allrules[rules[customRule + 1]].alertText, dateAndTimeFormats);
  }
}

// eslint-disable-next-line consistent-return
function setFaxUploadValidation(field) {
  var fileInput = field[0];
  var fileTypes = fileInput.getAttribute('data-file-types').split(',');

  for (var index = 0; index < fileTypes.length; index += 1) {
    fileTypes[index] = fileTypes[index].trim().replace(/\./g, '');
  }

  var regex = new RegExp('.(?:' + fileTypes.join('|') + ')$', 'i');

  if (!regex.test(field.val())) {
    $('.saving').prop('disabled', true);

    return '* Invalid file type';
  }

  $('.saving').prop('disabled', false);
}

function forceLogout() {
  window.location = '/portal/login/logout/expired';
}

var checkSessionTimeout;

function checkSession(secondAttempt) {
  if (secondAttempt === undefined) {
    secondAttempt = false;
  }

  if (secondAttempt) {
    log('checkSession secondAttempt');
  } else {
    log('checkSession');
  }

  $.ajax({ url: '/portal/home/checkSession', timeout: 30000 }).done(function (data) {
    if (typeof data !== 'undefined' && data.trim() !== 'ok') {
      if (secondAttempt) {
        forceLogout();
      }

      setTimeout(function () {
        checkSession(true);
      }, 5000);
    } else {
      if (checkSessionTimeout) {
        clearTimeout(checkSessionTimeout);
      }

      checkSessionTimeout = setTimeout(function () {
        checkSession();
      }, 180000);
    }
  }).fail(function () {
    log('checkSession request failed, retrying in 30s');

    checkSessionTimeout = setTimeout(function () {
      checkSession();
    }, 30000);
  });
}

function printDiv(divId) {
  var cssLink = '<link rel="stylesheet" type="text/css" href="/portal/css/myprintstyle.css">';

  window.frames.print_frame.document.body.innerHTML = cssLink + $('#' + divId).html();
  window.frames.print_frame.window.focus();
  window.frames.print_frame.window.print();
}

/**
 * center a modal on screen based on dimensions. trace modals resize width as well as height.
 *
 * @param {string} css is the link html for css
 * @param {string} html is the content to be printed
 * */
function printFrame(css, html) {
  log('printFrame');

  window.frames.print_frame.document.head.innerHTML = css;
  window.frames.print_frame.document.body.innerHTML = html;

  // fetch print css file and wait for it to load before printing
  $('[name=\'print_frame\']')
    .contents()
    .find('#print-styles')
    .on('load', function () {
      window.frames.print_frame.window.focus();
      window.frames.print_frame.window.print();
    });
}

/**
 * print a call center report
 * */
function printReport() {
  log('printReport');

  var css = '<link id="print-styles" rel="stylesheet"'
    + ' type="text/css" href="/portal/css/myprintstyle.css">';
  var dateFrom = $('#modal-from-0').data('raw-date');
  var dateTo = $('#modal-to-0').data('raw-date');
  var type = $('#stat_type option[value=\'' + $('#stat_type').val() + '\']').text();
  var title = '<h2>' + type + ': ' + dateFrom + ' &mdash; ' + dateTo + '</h2>';
  var graphTitle = '<h3>' + $('#graph-type-label').text() + ' Graph</h3>';
  var $tableBody = $('#modal-table-div .dataTables_scrollBody tbody')[0].outerHTML;
  var $tableHeader = $('#modal_stats_table_wrapper .dataTables_scrollHead thead')[0].outerHTML;
  var $statsTable = '<table class="table table-condensed table-hover table-bordered dataTable">'
    + $tableHeader
    + $tableBody
    + '</table>';
  var html = title + graphTitle + $('#modal-graph-div').html() + $statsTable;

  printFrame(css, html);
}

/**
 * adjusts contacts dock max-height based on window height.
 *
 * */
function contactsResize() {
  var dockContacts = $('.dock-contacts');
  var dockBody = dockContacts.find('.dock-body');
  // grab heights of window, contacts headers, footer
  var windowHeight = $(window).height();
  var dockHeadHeight = dockContacts.find('.dock-head').outerHeight();
  var contactsHeadHeight = dockContacts.find('.dock-contacts-header').outerHeight();
  var contactsGroupsHeight = dockContacts.find('.groups-container').outerHeight();
  var domainHeight = 0;

  // subtract headers/footers heights from window height, plus some margin
  // and give max-height to contacts scroll container
  // double contactsGroupsHeight because of contacts/recent toggle
  var maxHeight = windowHeight
    - dockHeadHeight
    - contactsHeadHeight
    - (contactsGroupsHeight * 2)
    - domainHeight
    - 20;

  dockContacts.find('.scroll-container').css('max-height', maxHeight + 'px');

  if (dockBody.is(':visible')) {
    dockContacts.find('.dock-popup').addClass('expanded');
  }
}

/**
 * decide whether to make a dropdown go up instead of down (default)
 *
 * @param {object} el should be the element that toggles the dropdown
 */
function getDropdownDirection(el) {
  var $dropdown = $(el).next('.dropdown-menu');

  // Invisibly expand the dropdown menu so its true height can be calculated
  $dropdown.css({
    visibility: 'hidden',
    display: 'block',
  });

  // Necessary to remove class each time so we don't unwantedly use dropup's offset top
  $(el).parent()
    .removeClass('dropup');

  // Determine whether bottom of menu will be below window at current scroll position
  if ($dropdown.offset().top - $(el).scrollParent()
    .offset().top - $(el).scrollParent()
    .scrollTop() + $dropdown.outerHeight() > $(el).scrollParent()
    .innerHeight() - $(el).scrollParent()
    .scrollTop()
  ) {
    $(el).parent()
      .addClass('dropup');
  }

  // Return dropdown menu to fully hidden state
  $dropdown.removeAttr('style');
}

/**
 * minimize a dock popup and save position of dock-contacts in a cookie
 *
 * @param {object} el is either the dock-minimize button or the dock-header
 */
function minimizeDockPopup(el) {
  var dockBody = $(el).parents('.dock-head')
    .siblings('.dock-body');

  var isContactsDock = $(el).parents('.dock-column')
    .hasClass('dock-contacts');

  var position = 'Dock.positon';

  if (dockBody.is(':visible')) {
    dockBody.hide();

    $(el).parents('.dock-column')
      .find('.dock-minimize i')
      .removeClass('glyphicon-chevron-down')
      .addClass('glyphicon-chevron-up')
      .attr('title', _('Maximize'));

    $(el).parents('.dock-popup')
      .removeClass('expanded');

    if (isContactsDock) {
      Cookies.set(position, 0, {
        expires: 365,
        path: '/',
      });
      Cookies.set(position, 0, {
        expires: 365,
        path: '/portal',
      });
    }
  } else {
    dockBody.show();
    $(el).parents('.dock-column')
      .find('.dock-minimize i')
      .removeClass('glyphicon-chevron-up')
      .addClass('glyphicon-chevron-down')
      .attr('title', _('Minimize'));

    contactsResize();

    if (isContactsDock) {
      Cookies.set(position, 1, {
        expires: 365,
        path: '/',
      });
      Cookies.set(position, 1, {
        expires: 365,
        path: '/portal',
      });
    }
  }
}

/**
 * bind accordion slide to chevron icon
 *
 * */
function bindAccordionSlide() {
  $('.panel-body').each(function () {
    $(this).on('show', function () {
      $(this).siblings('.panel-heading')
        .find('.glyphicon-chevron-up')
        .removeClass('glyphicon-chevron-up')
        .addClass('glyphicon-chevron-down');
    });

    $(this).on('shown.bs.tab', function () {
      $(this).parents('.modal')
        .trigger('resize');
    });

    $(this).on('hide', function () {
      $(this).siblings('.panel-heading')
        .find('.glyphicon-chevron-down')
        .removeClass('glyphicon-chevron-down')
        .addClass('glyphicon-chevron-up');
    });

    $(this).on('bs.hidden', function () {
      $(this).parents('.modal')
        .trigger('resize');
    });
  });
}

/**
 * initialize bootstrap tooltips on elements with 'helpsy' class
 *
 * */
function initTooltips() {
  function initTooltip(element, placement) {
    if (element.length > 1) {
      element.each(function (index, item) {
        initTooltip($(item), placement);
      });

      return;
    }

    var options = {
      delay: {
        show: 400,
        hide: 100,
      },
      placement: placement,
    };

    if (element.data('tooltip-container')) {
      options.container = element.data('tooltip-container');
    }

    options.title = function () {
      return $(this).data('tooltip-title') || $(this).attr('title');
    };

    element.tooltip(options);
  }

  function tooltipTop(element) {
    return initTooltip(element, 'top');
  }

  function tooltipRight(element) {
    return initTooltip(element, 'right');
  }

  function tooltipBottom(element) {
    return initTooltip(element, 'bottom');
  }

  function tooltipLeft(element) {
    return initTooltip(element, 'left');
  }

  function initOverlay(element) {
    var title = element.data('original-title');

    return $('<div></div>').addClass('helpsy')
      .attr('title', title)
      .css({
        position: 'absolute',
        top: element.position().top + 'px',
        left: element.position().left + 'px',
        width: element.outerWidth() + 'px',
        height: element.outerHeight() + 'px',
        zIndex: '1000',
        backgroundColor: '#fff',
        opacity: '0',
      });
  }

  // init tooltips
  tooltipTop($('.helpsy'));
  tooltipRight($('.helpsy-right'));
  tooltipBottom($('.helpsy-buttom'));
  tooltipLeft($('.helpsy-left'));

  // init tooltips for disabled buttons
  $('.helpsy:disabled').each(function () {
    var $self = $(this);
    var overlay = initOverlay($self);

    overlay = tooltipTop(overlay);
    $self.after(overlay);
  });

  $('.helpsy-right:disabled').each(function () {
    var $self = $(this);
    var overlay = initOverlay($self);

    overlay = tooltipRight(overlay);
    $self.after(overlay);
  });

  $('.helpsy-buttom:disabled').each(function () {
    var $self = $(this);
    var overlay = initOverlay($self);

    overlay = tooltipBottom(overlay);
    $self.after(overlay);
  });

  $('.helpsy-left:disabled').each(function () {
    var $self = $(this);
    var overlay = initOverlay($self);

    overlay = tooltipLeft(overlay);
    $self.after(overlay);
  });
}

function dayOfWeekCheck() {
  var inError = false;

  if ($('#TimeframeSelectOption2').is(':checked') && !$('#TimeframeSelectOption3').is(':checked')) {
    var fields = $('.slider_checkbox').serializeArray();

    if (fields.length == 0) {
      inError = true;
    }
  }

  if (inError) {
    $('input[type=submit]').prop('disabled', true);
  } else {
    $('input[type=submit]').prop('disabled', false);
  }
}

/**
 * force validation for js -> submit method. initiate button loading if applicable
 *
 */
function forceValidate(form) {
  log('forced validation on ' + form);

  var validated = $(form).validationEngine('validate');

  if (validated) {
    $(form + ' .saving').button('loading');

    return true;
  }

  return false;
}

// attach validationEngine to forms
function attachValidation() {
  $('form').validationEngine('attach', {
    autoHidePrompt: true,
    scroll: false,
    onValidationComplete: function (form, status) {
      if (status && form != null) {
        $('.saving').button('loading');
      }

      return status;
    },
    onFailure: function () {
      log('onFailure');
    },
  });

  // delay validation on keyup for password
  var delay = (function () {
    var timer = 0;

    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  }());

  $('#confirm-new-password').on('keyup', function () {
    delay(function () {
      $('form').validationEngine('validateField', '#confirm-new-password');
    }, 1000);
  });

  // clicking cancel button hides red notifications
  $('.cancel').on('click', function () {
    $('form').validationEngine('hideAll');
  });

  $('ul.nav a').on('click', function () {
    $('form').validationEngine('hideAll');
  });

  // losing autcomplete field focus hides notification
  $('#choices').on('blur', function () {
    $('#choices').validationEngine('hide');
  });

  // hide any error prompts if a new radioSlide option is selected
  $('.radioSlide').on('change', function () {
    $('.datepicker').validationEngine('hide');
    $('.input-hour-minute').validationEngine('hide');
    dayOfWeekCheck();
  });

  // unbind the blur event from datepicker fields to prevent unwanted
  // validation until form is submitted.
  $('.datepicker, .datetimepicker').off('blur');
}

// toggle slidedown of add time frame options
function radioSlide() {
  // show selected radio option div on edit
  $('input.radioSlide:checked').each(function () {
    var selected = $(this).val();

    $('#' + selected).show();
  });

  // show selected radio options when clicking each radio
  $('input.radioSlide').on('change', function () {
    var selected = $(this).val();

    if (selected == 'option1') {
      $('.timeframe-divider').fadeOut();
    } else {
      $('.timeframe-divider').fadeIn();
    }

    $('.slide')
      .animate({
        height: 'hide',
        opacity: 'hide',
      });

    $('#' + selected)
      .animate({
        height: 'show',
        opacity: 'show',
      });
  });
}

function toggleSiteManagerScope() {
  setTimeout(function () {
    if ($('#site').length === 0 || $('#site').val() === '') {
      $('#UserScope option[value*=\'Site Manager\']').prop('disabled', true);
    } else {
      $('#UserScope option[value*=\'Site Manager\']').prop('disabled', false);
    }
  }, 100);
}

/**
 * Function adds jQuery based on whether Agent number is "off net" - 10 digit phone number,
 * indicating outside system
 *
 * @param {boolean} isOffnet
 * @param {string} type
 */
function hqAgentOffnet(isOffnet, type) {
  if (isOffnet) {
    $('#device').attr('class', 'large validate[required]');
    $('#remote-agent-label').removeClass('hidden');
    // show offnet name field
    $('#group-for-offnet-name').removeClass('hidden');
    $('#isOffnet').val('yes');

    $('#CallQueueLoginType').html('<option value="Disabled">'
      + _('Offline')
      + '</option><option value="offnet">'
      + _('Online')
      + '</option>');

    log(type);

    if (type == 'offnet' || type == 'Logged In') {
      $('#CallQueueLoginType').val('offnet');
    } else {
      $('#CallQueueLoginType').val('Disabled');
    }

    $('#groupforwrap, #group-for-maxcalls, #group-for-priority, #group-for-autoanswer, #group-for-maxsms')
      .addClass('hidden');
  } else {
    $('#device').attr('class', 'form-control large validate[required,ajax[agentAdd]]');
    $('#remote-agent-label').addClass('hidden');
    // hide offnet name field
    $('#group-for-offnet-name').addClass('hidden');
    $('#isOffnet').val('no');

    // REMOVED 1226 <option value=\"Available One Call\">Online: One Call</option>");
    $('#CallQueueLoginType').html('<option value="Logged Out">'
      + _('Offline')
      + '</option><option value="Logged In">'
      + _('Online')
      + '</option>');

    if (type == 'Logged In' || type == _('Online') || type == 'Online') {
      $('#CallQueueLoginType').val('Logged In');
    } else if (type == 'Logged Out' || type == _('Offline') || type == 'Offline') {
      $('#CallQueueLoginType').val('Logged Out');
    } else {
      $('#CallQueueLoginType').val('Available One Call');
    }

    $('#groupforwrap, #group-for-maxcalls, #group-for-priority, #group-for-autoanswer, #group-for-maxsms')
      .removeClass('hidden');
  }
}

function agentsTableHeight(refresh) {
  log('adjusting agents table height');

  var modal = $('#write-agents');
  var bodyHeight = parseInt(modal.find('.modal-body').css('max-height'), 10);

  $('#add-agents-table').css({ height: (bodyHeight - 20) + 'px' });

  if (refresh) {
    modal.find('.modal-header, .modal-footer').fadeIn(25, function () {
      modal.find('.modal-body')
        .css('display', 'block');
    });
  } else {
    modal.find('.modal-header, .modal-footer').fadeIn(25, function () {
      modal.find('.modal-body')
        .animate({
          height: 'show',
          opacity: 'show',
        }, { duration: 100 });
    });
  }
}

function enableAgentDelete() {
  $('#CallQueueToDelete').val('DELETE');
}

function hideAddEdit() {
  var selected = 'addedit';

  $('#' + selected).slideUp();
}

function phoneShowOptions(isAdd) {
  if (isAdd != '1') {
    isAdd = false;
  } else {
    isAdd = true;
  }

  var model = $('#PhoneModel').val();
  var getModelDataUri = '/portal/inventory/getModelData/' + encodeURIComponent(model);

  $.getJSON({
    url: getModelDataUri,
    success: function (result) {
      var lineCount = parseInt(result.phone_ext > 0 ? result.phone_ext : result.fxs, 10);

      $('#PhoneLine').find('option:not(:first)').remove();

      for (i = 2; i <= lineCount; i++) {
        $('#PhoneLine')
          .append($('<option>', {
            value: i,
            text: i,
          }));
      }
    },
  });

  if (model != '' && model != 'Manual or Softphone') {
    $('#macLineDiv')
      .animate({
        height: 'show',
        opacity: 'show',
      }, { queue: false },);

    $('#manualDiv')
      .animate({
        height: 'hide',
        opacity: 'hide',
      }, { queue: false },);
  } else {
    $('#macLineDiv')
      .animate({
        height: 'hide',
        opacity: 'hide',
      }, { queue: false },);

    if (!isAdd) {
      $('#manualDiv')
        .animate({
          height: 'show',
          opacity: 'show',
        }, { queue: false });
    }
  }
}

function greetingFadeCallback(select) {
  var selected = $(select).val();

  if ($('.toggle-placeholder').is(':hidden')) {
    $('.toggle-placeholder').slideDown();
  }

  if ($('.toggle-placeholder .slide').is(':visible')) {
    $('.toggle-placeholder .slide:visible')
      .stop()
      .fadeOut(200, function () {
        $(`#${selected}`).fadeIn(200);
      });
  } else {
    $(`#${selected}`).fadeIn(200);
  }

  if ($('.new-greeting .upload-radio').prop('checked')) {
    $('#save_button_js')
      .hide()
      .prop('disabled', true);

    $('#save_tts_btn')
      .hide()
      .prop('disabled', true);

    $('#save_button_form')
      .prop('disabled', false)
      .show()
      .val('Upload');
  } else if ($('.new-greeting .text-to-speech-radio').prop('checked')) {
    $('#save_button_form')
      .hide()
      .prop('disabled', true);

    $('#save_button_js')
      .hide()
      .prop('disabled', true);

    $('#save_tts_btn')
      .prop('disabled', false)
      .show();
  } else {
    $('#save_button_form')
      .hide()
      .prop('disabled', true);

    $('#save_tts_btn')
      .hide()
      .prop('disabled', true);

    $('#save_button_js')
      .prop('disabled', false)
      .show()
      .val('Call')
      .data('loading-text', 'Calling...');
  }
}

function greetingFade() {
  $('#moh00_enabled').on('click', function () {
    if ($('#MusicSelectRecordNumber').is(':checked')) {
      $('#save-js').show();
      $('#save-form').addClass('hidden');
    }
  });

  $(':button[value="Add Greeting"],#moh00_enabled').on('click', function () {
    if ($(':input[value="record-number"]').is(':checked')) {
      $('input.greetingFade').each(function () {
        greetingFadeCallback(this);
      });
    }
  });

  $('input.greetingFade').on('change', function () {
    greetingFadeCallback(this);
  });
}

// used after clicking 'save' on greeting
function greetingAddEditClose() {
  $('#greetingAddEdit')
    .animate({
      height: 'hide',
      opacity: 'hide',
    }, 750);
}

function updateGreetingDD() {
  $.getJSON('/portal/users/greetings/json/' + subUser + '@' + subDomain + '/*', function (data) {
    log(data);

    $.each(data, function (key, val) {
      var isFound = false;
      var totest = val.index + ' - ' + val.moh_script;

      $('#greeting-select option').each(function () {
        if (totest == $(this).text()) {
          isFound = true;
          log('found ' + totest);
        }
      });

      if (!isFound) {
        $('#greeting-select').append(
          $('<option />').val(val.remotepath)
            .html(totest),
        );
      }
    });
  });
}

// shows/hides intro greetings sections in AA intro greetings modal
function introsAddEdit(index, script, edit, message) {
  var addedit = $('#greetingAddEdit');

  if (typeof message === 'undefined') {
    message = '';
  }

  $('#UserEditNumber').val(index);
  $('#UserGreeting').val(index);
  $('#UserTimeFrame').val(script);
  $('#UserTimeFrame2').val(script);
  $('#intro_enabled_changed').val('1');

  if (script === '') {
    $('#UserTimeFrame').prop('disabled', false);
    $('#UserTimeFrame').attr('class', 'xlarge validate[required]');
  } else {
    $('#UserTimeFrame').prop('disabled', true);
    $('#UserTimeFrame').attr('class', 'xlarge ');
  }

  $('#messageText').val(message);

  var bodyHeight = parseInt($('#introgreeting-modal').find('.modal-body')
    .css('max-height'), 10);
  // gave a hard value because outerHeight calculates inconsistently
  var addeditHeight = 243;

  if (!edit) {
    $('#newGreetingTimeframeSelect').prop('disabled', false);
  }

  // if editing a greeting do...
  if (edit) {
    // if addedit section is hidden show it
    if (addedit.is(':hidden')) {
      $('#UserGreetingName').val(script);
      $('#newGreetingTimeframeSelect')
        .val(script)
        .prop('disabled', true);

      // modal body - addEdit div
      $('.greetings-table').animate(
        { height: bodyHeight - addeditHeight + 'px' },
        {
          duration: 550,
          queue: false,
        },
      );

      addedit.animate(
        {
          height: 'show',
          opacity: 'show',
        },
        {
          duration: 550,
          queue: false,
        },
      );
    } else {
      // otherwise fade section out and in with greeting's values
      addedit.fadeOut(100, function () {
        $('#UserGreetingName').val(script);
        $('#newGreetingTimeframeSelect')
          .val(script)
          .prop('disabled', true);
        addedit.fadeIn(100);
      });
    }
  } else if (addedit.is(':visible') && $('#UserTimeFrame').val() == '') {
    // if addedit section is visible and the name value is blank, hide the addedit section
    // modal body - 20px padding/margin
    $('.greetings-table').animate(
      { height: bodyHeight - 20 + 'px' },
      {
        duration: 550,
        queue: false,
      },
    );

    addedit.animate(
      {
        height: 'hide',
        opacity: 'hide',
      },
      {
        duration: 550,
        queue: false,
      },
    );
  } else if (addedit.is(':visible')) {
    // otherwise if it's visible but has greetings values, fade out/in and overwrite them
    // for a new greeting
    addedit.fadeOut(100, function () {
      $('#UserGreetingName').val(script);
      $('#newGreetingTimeframeSelect').val(script);
      addedit.fadeIn(100);
    });
  } else {
    // otherwise just show the addedit section to add a new greeting
    $('#UserGreetingName').val(script);
    $('#newGreetingTimeframeSelect').val(script);

    // modal body - addEdit div
    $('.greetings-table').animate(
      { height: bodyHeight - addeditHeight + 'px' },
      {
        duration: 550,
        queue: false,
      },
    );

    addedit.animate(
      {
        height: 'show',
        opacity: 'show',
      },
      {
        duration: 550,
        queue: false,
      },
    );
  }
}

// used after clicking 'save' on greeting
function introsAddEditClose() {
  $('#greetingAddEdit')
    .animate({
      height: 'hide',
      opacity: 'hide',
    }, 750);
}

// calculates table height on modal load and display
// form is a boolean that indicates if the greetingstable is being loaded after an ajax form submit
function greetingsTableHeight(form) {
  var modal = $('#greetings-modal');

  log('adjusting greetings table height');

  if ($('#introgreeting-modal').length) {
    modal = $('#introgreeting-modal');
  }

  var addedit = $('#greetingAddEdit');
  var bodyHeight = parseInt(modal.find('.modal-body').css('max-height'), 10);
  // misses some margin from a field
  var addeditHeight = 233;

  if (addedit.hasClass('nohide')) {
    $('.greetings-table').css({ height: (bodyHeight - addeditHeight - 20) + 'px' });
  } else {
    // outerHeight of addEdit div - 20px padding
    $('.greetings-table').css({ height: (bodyHeight - 20) + 'px' });
  }

  if (form) {
    modal.find('.modal-header, .modal-body, .modal-footer').fadeIn(25);
  } else {
    modal.find('.modal-header, .modal-footer').fadeIn(25, function () {
      modal.find('.modal-body')
        .animate({
          height: 'show',
          opacity: 'show',
        }, { duration: 100 });
    });
  }
}

function toggleMoh0() {
  if ($('#moh00_enabled').prop('checked')) {
    $('#moh0manage')
      .animate({
        height: 'show',
        opacity: 'show',
      });
  } else {
    $('#moh0manage')
      .animate({
        height: 'hide',
        opacity: 'hide',
      });

    $('#upload_div, #record_div').hide();
  }
}

function showUpload() {
  $('#record_div').hide();
  $('#upload_div').show();
}

function showRecord() {
  $('#upload_div').hide();
  $('#record_div').show();
}

function showMoreTZoptions() {
  var selectString = '#UserTimeZone';
  var mySelect = $(selectString);

  if (typeof mySelect === 'undefined' || mySelect.length == 0) {
    selectString = '#DomainTimeZone';
    mySelect = $(selectString);
  }

  if (mySelect.val() == _('show more...')) {
    var optVals = [];

    $(selectString + 'Storage option').each(function () {
      if ($(this).val() != '') {
        optVals.push($(this).val());
      }
    });

    $.each(optVals, function (val, text) {
      mySelect.append(
        $('<option />').val(text)
          .html(text),
      );
    });

    $(selectString).find('option')
      .prop('selected', false);

    $(selectString + ' option[value=\'show more...\']').remove();
  }
}

function addLocationToggle() {
  // reveal the duplicate location inputs change the button to be x helpsy instead if it is to show
  if ($('#add-location').hasClass('add-state')) {
    showAddLocation();
  } else {
    // cancel Add Location
    hideAddLocation();
  }
}

function showAddLocation() {
  var $controlGroup = $('.address-control-group');
  var $controlGroupNotify = $('.address-control-group-notify');

  $('.address-duplicate-control-group').removeClass('hidden');
  $('#add-location')
    .removeClass('add-state')
    .text(_('Cancel'));

  // hide the original dropdowns
  $controlGroup.addClass('hidden');
  $controlGroupNotify.addClass('hidden');

  // hide Edit Address button
  $('#edit-address').addClass('hidden');

  modalResize($controlGroup.closest('.modal'));
  modalResize($controlGroupNotify.closest('.modal'));
}

function hideAddLocation() {
  var $addressId = $('#address_id');
  var $controlGroup = $('.address-control-group');
  var $controlGroupNotify = $('.address-control-group-notify');

  $('#address_name_duplicate').val('');
  $('#location_duplicate').val('');

  $('.address-duplicate-control-group').addClass('hidden');

  $('#add-location')
    .addClass('add-state')
    .text(_('Add my location description'));

  // show the original dropdowns IF the value is add an address
  if ($addressId.val() === 'add_address_id') {
    $controlGroup.removeClass('hidden');
    $controlGroupNotify.removeClass('hidden');
  }

  // see if should show edit address
  var value = $addressId.val();

  if (addressesJs != null
    && Array.isArray(addressesJs)
    && addressesJs['0'] != null
    && value != null
  ) {
    // get the address chosen from dropdown from the list of all addresses
    var chosenAddress = addressesJs.find(function (o) {
      return o.address_id === value;
    });

    // set the address pretty print help text to the chosen address
    if (chosenAddress != null) {
      // only show address if the address belongs to the current logged-in user (this is so that you cannot dox someone else by looking at their profile)
      if (chosenAddress.user === '*'
        || chosenAddress.user == userSite
        || chosenAddress.domain_level != null
        || chosenAddress.site_level != null
        || chosenAddress.user == subUser
      ) {
        $('#address_pretty_print').text(chosenAddress.pretty_print);

        // TODO: also show edit options only show edit option if it is user level..
        if (chosenAddress.domain_level != null || chosenAddress.site_level != null) {
          $('#edit-address').addClass('hidden');
        } else {
          $('#edit-address').removeClass('hidden');
        }
      }
    }
  }

  modalResize($controlGroup.closest('.modal'));
  modalResize($controlGroupNotify.closest('.modal'));
}

// shows more options for address adding for various add/edit routes
function showAddressAddProfile(value, addressesJs, userSite) {
  var $controlGroup = $('.address-control-group');
  var $controlGroupNotify = $('.address-control-group-notify');

  cancelAddressEdit();
  hideAddLocation();

  // Handle "None" selection
  if (value === 'none') {
    $controlGroup.addClass('hidden');
    $controlGroupNotify.addClass('hidden');
    $('.saveBtn').prop('disabled', false);
    $('.valBtn').addClass('hidden');
    $('#address_pretty_print').text('').addClass('hidden');
    $('#edit-address').addClass('hidden');
    $('#add-location').addClass('hidden');
    return; // Exit early
  }

  if (value === 'add_address_id') {
    $controlGroup.removeClass('hidden');
    $controlGroupNotify.removeClass('hidden');

    // disable save button for now
    $('.saveBtn').prop('disabled', true);

    // show the validate button
    $('.valBtn').removeClass('hidden');

    // resize modal
    modalResize($controlGroup.closest('.modal'));
    modalResize($controlGroupNotify.closest('.modal'));

    // hide/reset any duplicate prompts that might be showing if you change to add_address option
    $('#address_name_duplicate').val('');
    $('#location_duplicate').val('');
    $('.address-duplicate-control-group').addClass('hidden');
    $('#add-location')
      .addClass('add-state')
      .addClass('hidden')
      .text(_('Add my location description'));
    $('#address_pretty_print').text('');

    // hide buttons for Add my location and Edit Address
    $('#edit-address').addClass('hidden');

    // make all the fields blank
    $('#address_name').val('');
    $('#caller_name').val('');
    $('#address_line_1').val('');
    $('#address_line_2').val('');
    $('#state_code').val('');
    $('#city').val('');
    $('#zip').val('');
    $('#location').val('');
  } else {
    // enable save button for now
    $('.saveBtn').prop('disabled', false);

    // hide the validate button
    $('.valBtn').addClass('hidden');

    // set the help text too
    $('#validate-address-message')
      .removeClass('text-success')
      .text(_('Validate a new address before saving. All fields must be filled out before validating.'));

    // resize modal
    modalResize($controlGroup.closest('.modal'));
    modalResize($controlGroupNotify.closest('.modal'));
  }

  // changed to a non-address value, can read and fill in the address information into the boxes, and also show the
  // show pretty print here
  if (addressesJs != null && Array.isArray(addressesJs) && addressesJs['0'] != null) {
    // get the address chosen from dropdown from the list of all addresses
    var chosenAddress = addressesJs.find(function (o) {
      return o.address_id === value;
    });

    // set the address pretty print help text to the chosen address
    if (chosenAddress != null) {
      // only show address if the address belongs to the current logged in user (this is so that you cannot dox someone else by looking at their profile)
      if (chosenAddress.user === '*'
        || chosenAddress.user == userSite
        || chosenAddress.domain_level != null
        || chosenAddress.site_level != null
        || chosenAddress.user == subUser
      ) {
        $('#address_pretty_print').text(chosenAddress.pretty_print);

        // TODO: also show edit options only show edit option if it is user level..
        if (chosenAddress.domain_level != null || chosenAddress.site_level != null) {
          $('#edit-address').addClass('hidden');
        } else {
          $('#edit-address').removeClass('hidden');
        }

        // fill in the values
        fillInAddressData(chosenAddress);
      } else {
        $('#address_pretty_print').text('');
      }
    } else {
      $('#address_pretty_print').text('');
    }
  }
}

/**
 * Apply adjusted address fields from validation response
 * Updates form fields with standardized address data based on carrier type
 * @param {Object} address - The address object containing standardized data and carrier info
 */
function applyAdjustedAddressToFields(address) {
  var standardized = address.standardized;
  var preDirectional;
  var postDirectional;
  var plusFour;

  if (['bandwidth', 'intrado'].includes(address.carrier)) {
    preDirectional = standardized.PreDirectional != null
      ? standardized.PreDirectional + ' '
      : '';

    postDirectional = standardized.PostDirectional != null
      ? standardized.PostDirectional + ' '
      : '';

    document.getElementById('address_line_1').value = standardized.HouseNumber + ' ' + preDirectional + ' ' + standardized.StreetName + ' ' + standardized.StreetSuffix + ' ' + postDirectional;
    document.getElementById('city').value = standardized.City;

    plusFour = standardized.PlusFour != null
      ? '-' + standardized.PlusFour
      : '';

    document.getElementById('zip').value = standardized.Zip + plusFour;

    return;
  }

  if (address.carrier == 'brightlink') {
    preDirectional = standardized.preDirectional != null
      ? standardized.preDirectional + ' '
      : '';
    postDirectional = standardized.postDirectional != null
      ? standardized.postDirectional + ' '
      : '';

    document.getElementById('address_line_1').value = standardized.houseNumber + ' ' + preDirectional + ' ' + standardized.streetName + ' ' + standardized.streetSuffix + ' ' + postDirectional;
    document.getElementById('city').value = standardized.city;
    document.getElementById('zip').value = standardized.zip + '-' + standardized.plusfour;

    return;
  }

  if (address.carrier == 'inteliquent') {
    // double check the inteliquent method, sometimes it will send a standardized object of null
    if (standardized.validationMsg == null || standardized.validationMsg != 'Valid address') {
      $('#validate-address-message').removeClass('text-success text-error');
      $('.valBtn').button('reset');

      $('#validate-address-message')
        .text(_('The entered address could not be found. Please make sure there are no errors or enter a different address.'));
      $('#validate-address-message').addClass('text-error');
      $('.valBtn').prop('disabled', true).show();
      $('.savBtn').prop('disabled', true).hide();

      return;
    }

    document.getElementById('address_line_1').value = standardized.HouseNumber + ' ' + standardized.StreetName + ' ' + standardized.StreetSuffix;
    document.getElementById('city').value = standardized.City;
    document.getElementById('zip').value = standardized.Zip;
  }
}

/**
 * Press edit address, should change edit flag to true.
 * Change the string of the button to be "Cancel".
 * Show the address information fields.
 */
function editAddressToggle() {
  var editFlagEle = document.getElementById('edit_flag');

  if (!editFlagEle) {
    return;
  }

  if (document.getElementById('edit_flag').value == 'false') {
    // toggling to true (Pressed Edit address)
    startAddressEdit();
  } else if (document.getElementById('edit_flag').value == 'true') {
    // toggling to false (Pressed Cancel)
    cancelAddressEdit();
  }
}

function startAddressEdit() {
  var $controlGroup = $('.address-control-group');
  var $controlGroupNotify = $('.address-control-group-notify');

  // toggling to true (Pressed Edit address)
  document.getElementById('edit_flag').value = 'true';

  // show the inputs
  $controlGroup.removeClass('hidden');
  $controlGroupNotify.removeClass('hidden');

  // value is the address_id that is currently selected
  var value = document.getElementById('address_id').value;
  var chosenAddress = addressesJs.find(function (o) {
    return o.address_id === value;
  });

  if (chosenAddress != null) {
    fillInAddressData(chosenAddress);
  }

  // change "Edit Address" link text to "Cancel"
  $('#edit-address').text(_('Cancel'));

  // hide Add my location button
  $('#add-location').addClass('hidden');

  // hide pretty print
  $('#address_pretty_print').addClass('hidden');

  // show validate button
  $('.valBtn').prop('disabled', false).show();

  modalResize($controlGroup.closest('.modal'));
  modalResize($controlGroupNotify.closest('.modal'));
}

function cancelAddressEdit() {
  // toggling to false (Pressed Cancel)
  var editFlagEle = document.getElementById('edit_flag');
  var $controlGroup = $('.address-control-group');
  var $controlGroupNotify = $('.address-control-group-notify');

  if (editFlagEle) {
    editFlagEle.value = 'false';
  }

  // hide the inputs
  $controlGroup.addClass('hidden');
  $controlGroupNotify.addClass('hidden');

  // change "Cancel" link text BACK to "Edit Address"
  $('#edit-address').text(_('Edit Address'));

  // bring back Add my location description button
  $('#add-location').removeClass('hidden');

  // reveal pretty print again
  $('#address_pretty_print').removeClass('hidden');

  // make sure save is not disabled anymore on cancel edit
  $('.saveBtn').prop('disabled', false);

  modalResize($controlGroup.closest('.modal'));
  modalResize($controlGroupNotify.closest('.modal'));
}

function fillInAddressData(chosenAddress) {
  document.getElementById('address_name').value = chosenAddress.address_name;
  document.getElementById('caller_name').value = chosenAddress.caller_name;
  document.getElementById('address_line_1').value = chosenAddress.address_line_1;
  document.getElementById('address_line_2').value = chosenAddress.address_line_2;
  document.getElementById('country_code').value = chosenAddress.country_code;
  document.getElementById('state_code').value = chosenAddress.state_code;
  document.getElementById('city').value = chosenAddress.city;
  document.getElementById('zip').value = chosenAddress.zip;

  if (typeof chosenAddress.location !== 'undefined'
    && document.getElementById('location') != null
  ) {
    document.getElementById('location').value = chosenAddress.location;
  }

  document.getElementById('carrier').value = chosenAddress.carrier;
}

// should require validate again because the user changed the address to be added
function userAddressChange() {
  // disable the save button
  $('.saveBtn').prop('disabled', true);

  // check if values are filled, if they are, then set validate button to be true
  isSaveValid();
}

/**
 * Make sure all address fields are filled before allowing to validate
 */
function isSaveValid() {
  var allowValidate = true;

  $('.isNeeded').each(function () {
    if ($(this).val() == '') {
      allowValidate = false;
    }
  });

  if (allowValidate) {
    $('.valBtn').prop('disabled', false).show();
    $('#validate-address-message')
      .addClass('muted')
      .removeClass('text-error text-success')
      .text(_('Validate a new address before saving. All fields must be filled out before validating.'));
  } else {
    $('.valBtn').prop('disabled', true);
  }
}

/**
 * Clears forms and hides sliding content
 * @param form
 */
function clearForm(form) {
  $(form)[0].reset();
  $('li[id*="slide"]').remove();

  findCheck();

  $(':text').trigger('blur');
}

function updateModalPosition() {
  var $topNavBar = $('body').find('.navbar-fixed-top');
  var $modalDialog = $('.modal-dialog');

  if ($topNavBar.length) {
    $modalDialog.css({ 'margin-top': `${$topNavBar.outerHeight(true)}px` });
  }
}

function modalResize() {
  // We need to leave this here because the NS Flow endpoint
  // includes JS that makes a call to this removed method.
}

function resizeTraceModal(modal, imageSources) {
  var modalDialog = modal.find('.modal-dialog');

  modal.css('maxHeight', `${$(window).height() - 30}px`);

  imageSources.forEach(function (imageSource) {
    var imageElement = new Image();

    imageElement.onload = function () {
      var imageWidth = imageElement.width;

      modalDialog.fadeIn(25, function () {
        console.log({
          imageWidth: imageWidth,
          modalDialogWidth: modalDialog.width(),
        });

        if (imageWidth <= modalDialog.width()) {
          return;
        }

        if (imageWidth > ($(window).width() - 30)) {
          imageWidth = $(window).width() - 30;
        } else {
          imageWidth += 30;
        }

        modalDialog.animate({
          width: imageWidth,
        }, {
          duration: 150,
          queue: false,
          complete: function () {
            modal.trigger('modal.animation.end');
            modalState = 'open';
          },
        });
      });
    };

    imageElement.src = imageSource;
  });
}

function clearModal(modal) {
  modal.find('.modal-content').empty();
  modal.modal('hide');
}

// hide modal modalId includes the #
function hideModal(modalId) {
  modalState = 'closing';

  var $modal = $(modalId);

  $modal.find('.modal-dialog').width('');

  clearModal($modal);
  $('form').validationEngine('hideAll');

  modalTimer = setTimeout(function () {
    if ($modal.is(':visible')) {
      clearModal($modal);
    }

    // remove any bound events to elements in modal
    $modal.off()
      .find('.modal-content')
      .html(`<div class="loading-container relative">
    <div class="loading-spinner la-ball-spin-clockwise">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>`)
      .removeAttr('style');

    $modal.removeClass('load-failed');

    modalState = 'closed';
  }, 1000);
}

// hide agent stats modal used in call center manager
// TODO: convert to take placeholder html, store in string, then use here
function hideAgentModal(modalId) {
  modalState = 'closing';

  if (modalId != '#view-agent-stats') {
    hideModal(modalId);

    return;
  }

  $('form').validationEngine('hideAll');
  $(modalId).modal('hide');

  modalTimer = setTimeout(function () {
    $(modalId).html(`<div class="modal-dialog modal-lg" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('#view-reports');">&times;
            </button>
            <h3>&nbsp;</h3>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-xs-12 col-sm-6 chart-container">
                    <span class="loading-lg chart_div"></span>
                    <div id="chart_div" class="chart-container"></div>
                </div>
                <div class="col-xs-12 col-sm-6 chart-container">
                    <span class="loading-lg chart_div2"></span>
                    <div id="chart_div2" class="chart-container"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6 chart-container">
                    <span class="loading-lg chart_div3"></span>
                    <div id="chart_div3" class="chart-container"></div>
                </div>
                <div class="col-xs-12 col-sm-6 chart-container">
                    <span class="loading-lg chart_div4"></span>
                    <div id="chart_div4" class="chart-container"></div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('#view-reports');">Close
            </button>
        </div>
    </div>
</div>`)
      .attr('style', '');
    modalState = 'closed';
  }, 1000);
}

// hide modal conditionally
function hideModalIf(modalId) {
  if (!$('#hideModal').length) {
    return;
  }

  modalState = 'closing';

  log('hiding modal, reload location');

  $(modalId).modal('hide');

  modalTimer = setTimeout(function () {
    $(modalId).html('<span class="loading-lg"></span>')
      .attr('style', '');
    modalState = 'closed';
  }, 1000);

  // eslint-disable-next-line no-restricted-globals
  location.reload();
}

function hideModalIfNoReload(modalId) {
  if ($('#hideModal').length) {
    modalState = 'closing';

    log('hiding modal, no reload');

    $(modalId).modal('hide');

    modalTimer = setTimeout(function () {
      $(modalId).html('<span class="loading-lg"></span>')
        .attr('style', '');
      modalState = 'closed';
    }, 1000);
  }
}

// reloads the contents of the modal. Used in save and delete cases
// where the table contents need to be updated
function reloadModal(modalId) {
  modalState = 'opening';

  var $modalObj = $(modalId);
  var modalPath = $modalObj.data('modal-path');
  var loadingHtml = '<div class="loading-container relative">'
    + '<div class="loading-spinner la-ball-spin-clockwise">'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '<div></div>'
    + '</div>'
    + '</div>';

  $modalObj.find('.modal-content').html(loadingHtml);

  $.ajax({
    url: modalPath,
    cache: false,
  })
    .done(function (html) {
      log('reloading modal data succeeded for ' + modalId);

      $modalObj.css('minHeight', $modalObj.height() + 'px');

      try {
        $modalObj.find('.modal-content').html(html);
      } catch (err) {
        log('error caught - ' + err);
      }

      $modalObj.find('.modal-header, .modal-body, .modal-footer').show();

      modalState = 'open';
    })
    .fail(function (textStatus) {
      $modalObj.addClass('load-failed');

      var html = `<div class="modal-dialog modal-md" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('${modalId}');">&times;
            </button>
            <h4>${textStatus.statusText}</h4>
        </div>
        <div class="modal-body">
            <div class="load-failed">
                <h4>${_('Contents failed to load.')}</h4>
                <h4>${_('Please try again.')}</h4>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button"
                    class="cancel btn btn-default"
                    data-dismiss="modal"
                    onclick="hideModal('${modalId}');">${_('Close')}
            </button>
        </div>
    </div>
</div>`;

      $modalObj.html(html);
      $modalObj.find('.modal-header, .modal-body, .modal-footer').show();
    });
}

/**
 * Get data stored on modal element
 *
 * @param {string} modalId
 * @param {string} key
 * @param {*} value
 *
 * @return {*}
 */
function setModalData(modalId, key, value) {
  var modalElement = $(modalId);

  if (!modalElement.length) {
    return;
  }

  modalElement.data(key, value);
}

/**
 * Get data stored on modal element
 *
 * @param {string} modalId
 * @param {string} dataKey
 * @param {*} [defaultValue]
 *
 * @return {*}
 */
function getModalData(modalId, dataKey, defaultValue) {
  var modalElement = $(modalId);

  if (!modalElement.length) {
    return defaultValue;
  }

  return modalElement.data(dataKey) || defaultValue;
}

// load content into modal and show it.
function loadModal(modalId, path, beforeLoadCallback, afterLoadCallback) {
  if (this.preventDefault !== undefined) {
    this.preventDefault();
  }

  if (beforeLoadCallback != null) {
    beforeLoadCallback();
  }

  modalState = 'opening';
  clearTimeout(modalTimer);

  log(`loading modal ${modalId} with data from ${path}`);

  var modalObj = $(modalId);
  var isNewModal = modalObj.css('display') !== 'block';

  if (isNewModal) {
    var loadingHtml = `<div class="loading-container relative">
    <div class="loading-spinner la-ball-spin-clockwise">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>`;

    modalObj.addClass('loading');
    modalObj.find('.modal-content').html(loadingHtml);
  }

  modalObj.data('modal-path', path);

  $.ajax({
    url: path,
    cache: false,
  }).done(function (html) {
    log(`loading modal data succeeded for ${modalId}`);

    modalObj.removeClass('loading');

    if (modalId === '#history-trace') {
      html = html.replace(/class="btn"/gi, 'class="btn btn-default"');
    }

    try {
      modalObj.find('.modal-content').html(html);
    } catch (err) {
      log(`error caught - ${err}`);
    }

    if (modalId === '#history-trace') {
      var callFlowImage = $('.callflow-image img');

      resizeTraceModal(modalObj, [callFlowImage.attr('src')]);
    } else {
      modalObj.find('.modal-header, .modal-footer').fadeIn(isNewModal ? 25 : 0);
      modalObj.find('.modal-body')
        .animate(
          {
            height: 'show',
            opacity: 'show',
          },
          {
            duration: isNewModal ? 100 : 0,
            complete: function () {
              modalObj.trigger('modal.animation.end');
            },
          },
        );
    }

    if (afterLoadCallback != null) {
      afterLoadCallback();
    }
  })
    .fail(function (textStatus) {
      modalObj.removeClass('loading').addClass('load-failed');

      var html = `<div class="modal-dialog" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('${modalId}');">
                &times;
            </button>
            <h4>${textStatus.statusText}</h4>
        </div>
        <div class="modal-body">
            <div class="load-failed">
                <h4>${_('Contents failed to load.')}</h4>
                <h4>${_('Please try again.')}</h4>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="cancel btn btn-default" data-dismiss="modal" onclick="hideModal('${modalId}');">
                ${_('Close')}
            </button>
        </div>
    </div>
</div>`;

      modalObj.html(html);
      modalObj.find('.modal-header, .modal-body, .modal-footer').show();
    });
}

// used for closing the current modal and showing the next modal. Needs current modal id,
// next modal id and next modal path
function loadNextModal(current, next, path) {
  var currentModal = $(current);
  var nextModal = $(next);

  var currentPath = currentModal.data('modal-path');

  nextModal.data('prev-modal-id', current);
  nextModal.data('prev-modal-path', currentPath);

  currentModal.on('hidden.bs.modal', function () {
    currentModal.find('.modal-body').html(`<div class="loading-spinner la-ball-spin-clockwise">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>`);
    nextModal.modal('show');
    loadModal(next, path);
    currentModal.off('hidden.bs.modal');
  });

  currentModal.modal('hide');
}

function showConfReport(confId) {
  if ($('#preview-' + confId).is(':visible')) {
    $('#participants-' + confId).animate(
      {
        height: 'hide',
        opacity: 'hide',
      },
      function () {
        $('#preview-' + confId).hide();
      },
    );
  } else {
    $('.subtable:visible div').animate(
      {
        height: 'hide',
        opacity: 'hide',
      },
      function () {
        $('.subtable')
          .not('#preview-' + confId)
          .hide();
      },
    );

    $('#preview-' + confId).show();
    $('#participants-' + confId)
      .animate({
        height: 'show',
        opacity: 'show',
      });
  }
}

function validateDateRange() {
  var isFrom = $('.isFrom');
  var isTo = $('.isTo');

  if (!isFrom.val() == '' && !isTo.val() == '') {
    var a = moment(isFrom.datepicker('getDate')).unix();
    var b = moment(isTo.datepicker('getDate')).unix();
    var daysRemaining = Math.floor((b - a) / 60 / 60 / 24);

    if (daysRemaining < 0) {
      $('input[type="submit"]').prop('disabled', true);
      isTo.validationEngine('showPrompt', '* Invalid range');
    } else {
      isTo.validationEngine('hide');
      $('input[type="submit"]').prop('disabled', false);
    }
  }
}

/**
 * creates a datepickers for various types based on slot
 *
 * @param {number} slot is the slot/index of the datepicker created
 */
function newDatePicker(slot) {
  var currentDate = moment();
  var toFilterInput = $('#to-' + slot);
  var fromFilterInput = $('#from-' + slot);

  $('.dateInventory ~ span, .time ~ span,.reportdate ~ span,.date ~ span,.timeTimeFrame ~ span,.timeframe ~ span')
    .not('hasDatePicker')
    .each(function () {
      $(this).on('click', function () {
        var dateInput = $(this)
          .siblings('.dateInventory,.time,.reportdate,.date,.timeTimeFrame,.timeframe');

        if (!dateInput.prop('disabled')) {
          dateInput.datepicker('show');
        }
      });
    });

  // Set the VALUE property and attribute of inputs with datepickers when the datepicker is used
  $('.dateInventory,.time,.reportdate,.date,.timeTimeFrame,.timeframe')
    .not('hasDatePicker')
    .each(function () {
      var dateFormat = this.getAttribute('data-date-format');
      var timeFormat = (this.getAttribute('data-time-format') || '').replace('tt', 'a');
      var dateTimeFormat = '';

      if (dateFormat && timeFormat) {
        dateTimeFormat = dateFormat + ' ' + timeFormat;
      } else if (dateFormat && !timeFormat) {
        dateTimeFormat = dateFormat;
      } else if (!dateFormat && !timeFormat) {
        dateTimeFormat = timeFormat;
      }

      $(this).on('change', function () {
        var newDate = moment(this.value, dateFormat + ' ' + timeFormat);

        if (newDate.isValid()) {
          this.value = newDate.format(dateTimeFormat);
          this.setAttribute('value', newDate.format(dateTimeFormat));
        }
      });
    });

  // this makes the class cdrScheduleCalendar2 into a datetimepicker with several
  // special necessities
  $('.cdrScheduleCalendar2').each(function () {
    $(this).datetimepicker({
      showHour: true,
      showMinute: true,
      showSecond: false,
      dateFormat: convertDateFormat(this.getAttribute('data-date-format'), datepickerConversionFormats),
      timeFormat: convertDateFormat(this.getAttribute('data-time-format'), datepickerConversionFormats),
      altFieldTimeOnly: false,
      altField: this.getAttribute('data-alt-field') || '',
      altFormat: this.getAttribute('data-alt-format'),
      altTimeFormat: this.getAttribute('data-alt-time-format'),
    });
  });

  $('.date')
    .not('hasDatePicker, .cdrScheduleCalendar2')
    .each(function () {
      $(this).datetimepicker({
        maxDate: moment(currentDate)
          .endOf('day')
          .toDate(),
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
        timeFormat: convertDateFormat(
          this.getAttribute('data-time-format'),
          datepickerConversionFormats,
        ),

        onSelect: function (selectedDate) {
          var dateTimeFormat = (this.getAttribute('data-date-format')
            + ' '
            + this.getAttribute('data-time-format')).trim().replace('tt', 'a');

          var newDate = moment(this.value, dateTimeFormat, false);

          if (newDate.isValid()) {
            newDate = newDate.format(dateTimeFormat);
            this.value = newDate;
            this.setAttribute('value', newDate);
          }

          $('[id=' + this.id + ']:hidden')
            .val(moment(this.value, dateTimeFormat, false).format(dateTimeFormat));

          var settings = $(this).data('datepicker').settings;
          var date = $.datepicker.parseDate(
            // eslint-disable-next-line no-underscore-dangle
            settings.dateFormat || $.datepicker._defaults.dateFormat,
            selectedDate,
            settings,
          );

          log('date select is ' + date + 'for box ' + this.id);

          if (this.id != 'from-' + slot) {
            log('$(\'#from-\' + slot).attr(value)-' + fromFilterInput.val());

            var start = fromFilterInput.datepicker('option', 'getDate');

            log('start-' + start);
            log('date-' + date);

            if (start > date) {
              var dateToSelector = toFilterInput;

              start.setDate(start.getDate() - 3);

              var newEnd = start;

              newEnd.setDate(newEnd.getDate() + 31);
              dateToSelector.datepicker('option', 'maxDate', newEnd);
              toFilterInput.datepicker('option', 'minDate', null);
            }
          }

          var a = new moment($('[id=from-' + slot + ']:hidden').val()).toDate();
          var b = new moment($('[id=to-' + slot + ']:hidden').val()).toDate();
          var difference = b - Math.round(a / 1000.0) * 1000;
          var daysRemaining = Math.floor(difference / 1000 / 60 / 60 / 24) + 1;

          if (daysRemaining < 0) {
            $('.filtersavebutton').prop('disabled', true);
            $('#to-0').validationEngine('showPrompt', '* Invalid range');
          } else if (daysRemaining > maxDays) {
            $('.filtersavebutton').prop('disabled', true);
            $('#to-0').validationEngine('showPrompt', '* Max range is ' + maxDays + ' days');
          } else {
            $('.filtersavebutton').prop('disabled', false);
            $('#to-0').validationEngine('hide');
          }

          if ($('#modal-from-' + slot).hasClass('ccmanagertablesModal')) {
            CallCenterReportGenerator.generate();
          }
        },

        onClose: function () {
          var dateTimeFormat = (this.getAttribute('data-date-format') + ' '
            + this.getAttribute('data-time-format')).trim().replace('tt', 'a');

          $('[id=' + this.id + ']:hidden')
            .val(moment(this.value, dateTimeFormat, false).format('MM/DD/YYYY'));
        },
      });
    });

  $('.reportdate')
    .not('hasDatePicker')
    .each(function () {
      var $element = $(this);
      var inputFrom = $('#modal-from-' + slot);
      var inputTo = $('#modal-to-' + slot);

      $element.datepicker({
        maxDate: moment(currentDate)
          .endOf('day')
          .toDate(),
        dateFormat: convertDateFormat($element.data('date-format'), datepickerConversionFormats),
        onSelect: function (selectedDate) {
          var $self = $(this);
          var newDate = moment($self.val(), $self.data('date-format'), false);

          if (newDate.isValid()) {
            newDate = newDate.format($self.data('date-format'));
            $self.val(newDate);
          }

          $self.data('raw-date', moment($self.val(), $self.data('date-format'), false)
            .format('MM/DD/YYYY'));

          log('date select is ' + selectedDate + ' for box ' + $self.id);

          var fromDate = moment(inputFrom.val(), inputFrom.data('date-format'), false);
          var toDate = moment(inputTo.val(), inputTo.data('date-format'), false);

          log('fromDate-' + fromDate);
          log('toDate-' + toDate);

          if (fromDate.isAfter(toDate)) {
            log('from date is greater than to date!');

            if ($self.id === ('from-' + slot) || $self.id === ('modal-from-' + slot)) {
              inputTo.val(moment(fromDate).format(inputTo.data('date-format')));
              inputTo.data('raw-date', moment(fromDate).format('MM/DD/YYYY'));
            } else {
              inputFrom.val(moment(toDate).format(inputFrom.data('date-format')));
              inputFrom.data('raw-date', moment(toDate).format('MM/DD/YYYY'));
            }
          }

          CallCenterReportGenerator.generate();
        },
        onClose: function () {
          var $self = $(this);

          $self.data('raw-date', moment($self.val(), $self.data('date-format'), false)
            .format('MM/DD/YYYY'));
        },
      });
    });

  // Timepicker Addon
  $('.time').not('hasDatePicker')
    .each(function () {
      $(this).datetimepicker({
        maxDate: moment(currentDate).endOf('day')
          .toDate(),
        showMinute: false,
        timeFormat: convertDateFormat(
          this.getAttribute('data-time-format'),
          datepickerConversionFormats,
        ),
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
        onSelect: function (dateText, timepicker) {
          // change minutes to either 00 or 59 to capture the whole day
          $('[id=' + this.id + ']:hidden').val(
            moment(
              $(this).val(),
              this.getAttribute('data-date-format') + ' ' + this.getAttribute('data-time-format'),
              false,
            ).format('MM/DD/YYYY h:mm a'),
          );

          var newDate;

          if (timepicker.hour == 0 && this.id.startsWith('from')) {
            newDate = timepicker.formattedDate + ' ' + timepicker.hour + ':00';
            $(this).datetimepicker('setDate', newDate);
          } else if (timepicker.hour == 23 && this.id.startsWith('to')) {
            newDate = timepicker.formattedDate + ' ' + timepicker.hour + ':59';
            $(this).datetimepicker('setDate', newDate);
          }

          var a = new moment($('[id=from-' + slot + ']:hidden').val()).toDate();
          var b = new moment($('[id=to-' + slot + ']:hidden').val()).toDate();
          var difference = b - Math.round(a / 1000.0) * 1000;
          var daysRemaining = Math.floor(difference / 1000 / 60 / 60 / 24) + 1;

          if (daysRemaining > maxDays) {
            $('.filtersavebutton').prop('disabled', true);
            $('#to-0').validationEngine('showPrompt', '* Max range is ' + maxDays + ' days');
          } else {
            $('#to-0').validationEngine('hide');
            $('.filtersavebutton').prop('disabled', false);
          }
        },
      });
    });

  $('.dateInventory').not('hasDatePicker')
    .each(function () {
      $(this).datepicker({
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
        monthNames: [
          _('January'),
          _('February'),
          _('March'),
          _('April'),
          _('May'),
          _('June'),
          _('July'),
          _('August'),
          _('September'),
          _('October'),
          _('November'),
          _('December'),
        ],
        dayNamesMin: [
          _('Su'),
          _('Mo'),
          _('Tu'),
          _('We'),
          _('Th'),
          _('Fr'),
          _('Sa'),
        ],
        onSelect: function () {
          // change minutes to either 00 or 59 to capture the whole day
          $('[id=' + this.id + ']:hidden').val(
            moment($(this).val(), this.getAttribute('data-date-format'), false)
              .format('YYYY-MM-DD'),
          );

          if ($('.dateInventory[disabled="disabled"]').length == 0) {
            // check that both date fields are enabled before validating
            validateDateRange(this.getAttribute('data-date-format'));
          }
        },
      });
    });

  var hasMinutes = false;

  if ($('.timeTimeFrame').hasClass('hasMinutes')) {
    hasMinutes = true;
  }

  $('#from-' + slot + '.timeTimeFrame.isFrom').not('hasDatePicker')
    .each(function () {
      $(this).datetimepicker({
        showMinute: hasMinutes,
        timeFormat: convertDateFormat(
          this.getAttribute('data-time-format'),
          datepickerConversionFormats,
        ),
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
      });
    });

  $('#to-' + slot + '.timeTimeFrame.isTo').not('hasDatePicker')
    .each(function () {
      $(this).datetimepicker({
        showMinute: hasMinutes,
        timeFormat: convertDateFormat(
          this.getAttribute('data-time-format'),
          datepickerConversionFormats,
        ),
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
      });
    });

  $('#from-' + slot + '.timeframe.isFrom').not('hasDatePicker')
    .each(function () {
      $(this).datepicker({
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
        onSelect: function () {
          $('[id=' + this.id + ']:hidden').val(
            moment($(this).val(), this.getAttribute('data-date-format'), false).format(
              'MM/DD/YYYY h:mm a',
            ),
          );
        },
        onClose: function () {
          var dFormat = toFilterInput[0].getAttribute('data-date-format');
          var testStartDate = moment(toFilterInput[0].value, dFormat, false);
          var testEndDate = moment(toFilterInput[0].value, dFormat, false);

          if (toFilterInput.val() != '') {
            if (testStartDate > testEndDate) {
              toFilterInput[0].value = testStartDate.format(dFormat);
            }
          } else if (toFilterInput.val() != '') {
            toFilterInput.val(testStartDate.format(dFormat));
          }

          $('[id=' + this.id + ']:hidden').val(
            moment($(this).val(), this.getAttribute('data-date-format'), false).format(
              'MM/DD/YYYY h:mm a',
            ),
          );

          $('[id=' + toFilterInput[0].id + ']:hidden').val(
            moment(
              $(toFilterInput[0]).val(),
              toFilterInput[0].getAttribute('data-date-format'),
              false,
            ).format('MM/DD/YYYY h:mm a'),
          );
        },
      });
    });

  $('#to-' + slot + '.timeframe.isTo').not('hasDatePicker')
    .each(function () {
      $(this).datepicker({
        dateFormat: convertDateFormat(
          this.getAttribute('data-date-format'),
          datepickerConversionFormats,
        ),
        onSelect: function () {
          $('[id=' + this.id + ']:hidden').val(
            moment($(this).val(), this.getAttribute('data-date-format'), false).format(
              'MM/DD/YYYY h:mm a',
            ),
          );
        },
        onClose: function () {
          var dFormat = toFilterInput[0].getAttribute('data-date-format');
          var testStartDate = moment(toFilterInput[0].value, dFormat, false);
          var testEndDate = moment(toFilterInput[0].value, dFormat, false);

          if (toFilterInput.val() != '') {
            if (testStartDate > testEndDate) {
              toFilterInput[0].value = testEndDate.format(dFormat);
            }
          } else if (toFilterInput.val() != '') {
            toFilterInput.val(testEndDate.format(dFormat));
          }

          $('[id=' + this.id + ']:hidden').val(
            moment($(this).val(), this.getAttribute('data-date-format'), false).format(
              'MM/DD/YYYY h:mm a',
            ),
          );

          $('[id=' + toFilterInput[0].id + ']:hidden').val(
            moment(
              $(toFilterInput[0]).val(),
              toFilterInput[0].getAttribute('data-date-format'),
              false,
            ).format('MM/DD/YYYY h:mm a'),
          );
        },
      });
    });
}

// dynamic form, date range text field additions
function dynamicDateField() {
  var scntDiv = $('#p_scents');
  var slotsMax = 50;
  var slotsAvailable = [];

  for (var i = slotsMax - 1; i >= $('#p_scents li').length; i -= 1) {
    slotsAvailable.push(i);
  }

  scntDiv.on('click', '#addScnt', function () {
    var timeformat = '';
    var slot;
    var newClass = $(this).attr('classToAdd');

    $('.helpsy').tooltip('hide');

    if (slotsAvailable.length > 0) {
      slot = slotsAvailable.pop();

      if (views.timeframes.timeformat != '') {
        timeformat = 'data-time-format="' + views.timeframes.timeformat + '"';
      }

      var dateFieldsHtml = `<li id="slide-${slot}">
    <div class="input-group">
        <input id="from-${slot}"
               name="data[option3][Timerange][${slot}][begin]"
               class="form-control date-field ${newClass} isFrom"
               type="text"
               data-date-format="${views.timeframes.dateformat}"
               ${timeformat} />
        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
    </div>
    <span class="text-muted text-md-center" style="margin-top: 5px;">&nbsp;${_('to')}&nbsp;</span>
    <div class="input-group">
        <input id="to-${slot}"
               name="data[option3][Timerange][${slot}][end]"
               class="form-control date-field ${newClass} isTo"
               type="text"
               data-date-format="${views.timeframes.dateformat}"
               ${timeformat} />
        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
    </div>
    <a href="#" class="btn btn-danger remScnt helpsy" title="${_('Remove')}">
        <span class="glyphicon glyphicon-minus"></span>
    </a>
</li>`;

      $(dateFieldsHtml)
        .appendTo(scntDiv)
        .hide()
        .animate(
          {
            height: 'show',
            opacity: 'show',
          },
          {
            complete: function () {
              initTooltips();
            },
          },
        );

      newDatePicker(slot);

      $('.date-field').each(function () {
        var widthClass = getFieldWidthClass(this, 80, 120);

        $(this).addClass(widthClass);
      });

      $('.date,.timeTimeFrame,.timeframe').not('hasDatePicker')
        .each(function () {
          var dateFormat = this.getAttribute('data-date-format');
          var timeFormat = this.getAttribute('data-time-format');
          var dateTimeFormat = '';

          if (dateFormat && timeFormat) {
            dateTimeFormat = dateFormat + ' ' + timeFormat;
          } else if (dateFormat && !timeFormat) {
            dateTimeFormat = dateFormat;
          } else if (!dateFormat && !timeFormat) {
            dateTimeFormat = timeFormat;
          }

          $(this).on('change', function () {
            var newDate = moment(this.value, dateFormat + ' ' + timeFormat);

            if (newDate.isValid()) {
              this.value = newDate.format(dateTimeFormat);
              this.setAttribute('value', newDate.format(dateTimeFormat));
            }
          });
        });
    }

    return false;
  });

  scntDiv.on('click', '.remScnt', function () {
    var li = this.parentNode;
    var slot;

    $('.helpsy').tooltip('hide');

    if (li.id != 'keep') {
      slot = li.id.substr(li.id.lastIndexOf('-') + 1);
      slotsAvailable.push(slot);

      $(this)
        .parent('li')
        .remove();
    }

    return false;
  });
}

function dynamicField(
  parentId,
  slotsMax,
  addBtnId,
  slideId,
  type,
  field,
  disableClass,
  effectClass,
  placeholder,
  removeClass,
  inputClass,
  colSizeClass,
) {
  var i;
  var parentElement = $(`#${parentId}`);
  var simDelay = (!!$('.sim-delay-btn').length);
  var slot = 0;
  var slotsAvailable = [];
  var currentSlots = $(`#${parentId} li`);

  colSizeClass = colSizeClass || 'col-xs-12';

  if (simDelay) {
    currentSlots = $(`#${parentId} > .sim-ring`);
  }

  for (i = slotsMax - 1; i >= currentSlots.length; i -= 1) {
    slotsAvailable.push(i);
  }

  parentElement.on('click', `#${addBtnId}`, function () {
    var elementHtml;
    var $btn;
    var id = `${slideId}-${slot}`;
    var isEmail = (!!parentId.startsWith('email-list'));
    var isFaxUser = !!parentId.startsWith('faxuser-list');
    var emailInputClasses = 'form-control validate[custom[email]]';

    if (disableClass) {
      emailInputClasses += ` ${disableClass}`;
    }

    if (effectClass) {
      emailInputClasses += ` ${effectClass}`;
    }

    if (slotsAvailable.length > 0) {
      slot = slotsAvailable.pop();

      if (simDelay) {
        elementHtml = `<div class="form-group sim-ring" id="${id}" style="display: none;">
    <div class="col-xs-offset-3 col-xs-9">
        <div class="input-group sim-delay">
            <input name="data[${type}][${field}][${slot}]"
                   class="form-control ${disableClass} ${effectClass}"
                   placeholder="${placeholder}"
                   type="text" />
            <div class="input-group-btn">
                <button type="button"
                        class="sim-delay-btn btn btn-default helpsy-right cb-simring cb-always-effect cb-dnd-effect"
                        title="${_('Ring Delay (sec)')}">
                    <span class="glyphicon glyphicon-time"></span>&nbsp;
                    <span class="delay-seconds-wrapper"></span>
                </button>
                <button type="button"
                        class="btn btn-danger helpsy ${removeClass} ${disableClass} ${effectClass}"
                        title="${_('Remove')}">
                            <span class="glyphicon glyphicon-minus"> <span class="sr-only">${_('Remove')}</span>
                </button>
            </div>
        </div>
    </div>
    <select id="${type}SimDelay${slot}"
            name="data[${type}][sim_delay][${slot}]"
            class="form-control sim-delay-drop"></select>
</div>`;
      } else if (isEmail) {
        elementHtml = `<li id="${id}" class="form-group" style="display:none;">
    <div class="${colSizeClass}">
        <div class="input-group">
            <input id="UserEmailAddress${slot}"
                   name="data[${type}][${field}][${slot}]"
                   class="${emailInputClasses}"
                   placeholder="${placeholder}"
                   type="text" />
            <span class="input-group-btn">
                <button type="button" class="btn btn-warning helpsy ${removeClass} ${disableClass} ${effectClass}" title="Delete">
                    <span class="glyphicon glyphicon-minus"><span class="sr-only">Delete</span>
                </button>
            </span>
        </div>
    </div>
</li>`;
      } else if (isFaxUser) {
        elementHtml = `<li id="${id}" style="display: none;">
    <div class="${colSizeClass}">
        <div class="input-group">
            <input id="FaxUsershare${slot}"
                   name="data[${type}][${field}][${slot}]"
                   class="form-control ${disableClass} ${effectClass}"
                   placeholder="${placeholder}"
                   type="text" />
            <div class="input-group-btn">
                <button type="button"
                        href="javascript:void(0)"
                        class="btn btn-warning helpsy ${removeClass} ${disableClass} ${effectClass}"
                        title="Delete">
                    <span class="glyphicon glyphicon-minus"><span class="sr-only">Delete</span>
                </button>
            </div>
        </div>
    </div>
</li>`;
      } else {
        elementHtml = `<li id="${id}" class="form-group" style="display:none;">
    <div class="${colSizeClass}">
        <div class="input-group">
            <input name="data[${type}][${field}][${slot}]"
                   class="form-control ${inputClass} ${disableClass} ${effectClass}"
                   placeholder="${placeholder}"
                   type="text" />
            <span class="input-group-btn">
                <button type="button"
                        class="btn btn-warning helpsy ${removeClass} ${disableClass} ${effectClass}"
                        title="Delete">
                    <span class="glyphicon glyphicon-minus"><span class="sr-only">Delete</span>
                </button>
            </span>
        </div>
    </div>
</li>`;
      }

      parentElement.append(elementHtml);

      var newElement = $(`#${id}`);

      if (simDelay) {
        $btn = newElement.find('.sim-delay-btn');

        var $dropdown = newElement.find('.sim-delay-drop');
        var $delaySpan = $dropdown.siblings('.input-group')
          .find('.sim-delay-btn .delay-seconds-wrapper');

        $('.sim-delay-drop')
          .first()
          .children()
          .clone()
          .appendTo(`#${type}SimDelay${slot}`);
        $dropdown[0].selectedIndex = 0;
        $delaySpan.text($dropdown.val());
      }

      newElement.animate(
        {
          height: 'show',
          opacity: 'show',
        },
        {
          complete: function () {
            if (simDelay) {
              initSimDelayPopover($btn);
            }

            initTooltips();
          },
        },
      );

      if (isFaxUser) {
        $(`#FaxUsershare${slot}`).attr('spellcheck', false);

        $(`#FaxUsershare${slot}`).autocomplete({
          autoFocus: true,
          minLength: 0,
          source: function (request, response) {
            var results = $.ui.autocomplete.filter(userChoices, request.term);

            if (!results.length) {
              $(`#FaxUsershare${slot}`).validationEngine(
                'showPrompt',
                _('* No matches found!'),
                'red',
                'bottomLeft',
                true
              );
            } else {
              $(`#FaxUsershare${slot}`).validationEngine('hide');
            }

            $(`#FaxUsershare${slot}`).data('tabblock', false);

            response(results);
          },
          select: function (event, ui) {
          }
        });
      }
    }

    placeholderInit($(`#${id} input`));

    if (isEmail) {
      $('form').validationEngine('detach');
      $(`#${slideId}-${slot} input`).addClass('validate[custom[email]]');
      $('form').validationEngine();
    }

    return false;
  });

  parentElement.on('click', `.${removeClass}`, function () {
    var formGroupElement = $(this).closest('.form-group');

    if (!formGroupElement.hasClass('keep')) {
      slot = formGroupElement
        .attr('id')
        .substr(formGroupElement.attr('id').lastIndexOf('-') + 1);
      slotsAvailable.push(slot);

      $(this).tooltip('destroy');

      formGroupElement.slideUp({
        complete: function () {
          formGroupElement.remove();
        },
      });
    }

    return false;
  });
}

/**
 * function to change audio source. used with #greeting-select in user voicemail page
 *
 * */
function changeAudioSource(path) {
  var audio = $('#audio-player-0');

  if ($('#audio-player-0-aac-1').length) {
    $('#audio-player-0-aac-1').attr('src', path + '&convert=aac');
  }

  if ($('#audio-player-0-aac-2').length) {
    $('#audio-player-0-aac-2').attr('src', path + '&convert=aac');
  }

  if ($('#audio-player-0-aac-3').length) {
    $('#audio-player-0-aac-3').attr('src', path + '&convert=signed');
  }

  if ($('#audio-player-0-wav-1').length) {
    $('#audio-player-0-wav-1').attr('src', path + '&convert=signed');
  }

  if ($('#audio-player-0-wav-2').length) {
    $('#audio-player-0-wav-2').attr('src', path + '&convert=ogg');
  }

  if ($('#audio-player-0-wav-3').length) {
    $('#audio-player-0-wav-3').attr('src', path + '&convert=aac');
  }

  audio[0].load();
}

/**
 * function changes the download source for the associated download button.
 * used in user voicemail page
 */
function changeDownloadSource(path, $downloadBtn) {
  if ($downloadBtn == null) {
    $downloadBtn = $('#audio-player-0').siblings('.download-audio-btn');
  }

  $downloadBtn.attr('href', `${path}&convert=signed`);
}

/**
 * download a file from a given path
 * this is being activated from pressing the export button
 */
function initDownloadFile() {
  $('.download-file').on('click', function () {
    var path = $(this).data('download-path');

    window.location = path;

    if ($(this).data('download-disable') == true) {
      $(this).prop('disabled', true);
    }
  });
}

// makes confirmation password field required if the new-password field is non-empty.
function newPassValidate() {
  $('#confirm-new-password').removeClass('validate[equals[new-password]]');
  $('#confirm-new-password').removeClass('validate[required,equals[new-password]]');
  $('#confirm-new-password').validationEngine('hide');

  if ($('#new-password').val() != '') {
    $('#confirm-new-password').addClass('validate[required,equals[new-password]]');
  } else {
    $('#confirm-new-password').addClass('validate[equals[new-password]]');
  }
}

function initFlashMessage(wait, fade) {
  $('#flashMessage').delay(wait)
    .fadeTo(fade, 0.00, function () {
      $(this).remove();
    });
}

function postValue(url, value, success, error) {
  var originalShownValue = $('.contacts-message2-text').text();
  var messageElement = document.getElementById('message');

  if (messageElement) {
    messageElement.blur();
  }

  if (value !== '') {
    $('.contacts-message2-text').text(decodeURIComponent(value).replace(/COLLON/g, ':'));
    $('.contacts-message2-text').css({ color: '#a2a2a2' });
  } else {
    $('.contacts-message2-text').text('Set a status message');
    $('.contacts-message2-text').css({ color: '#08c' });
  }

  $.post(url + '/' + value, $.noop)
    .fail(function () {
      // switch back to original value if error occurred
      $('.contacts-message2-text').text(originalShownValue);

      if (error != null) {
        jsFlash(error, 'danger');
      }
    })
    .done(function () {
      if (success != null) {
        jsFlash(success, 'success');
      }
    });
}

function onBlurStatus() {
  $('#contacts-message').hide();
  $('#contacts-message2').show();
}

function traceBack(target, hide) {
  var toHide = document.querySelectorAll(hide);

  $(target).hide();
  $(target).html('');

  for (var i = 0; i < toHide.length; ++i) {
    toHide[i].style.display = 'block';
  }
}

function exportTrace(url) {
  url += '&type=csv';
  window.location = url;
}

function saveTrace(url) {
  jsFlash(_('Generating share link...'), 'info');
  url += '&type=1';

  try {
    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Promise(function (resolve) {
          $.getJSON(url, function (data) {
            var key = '';

            if (data !== null) {
              key = data.key;
            }

            console.log(key);
            resolve(new Blob([key], { type: 'text/plain' }));
          });
        }),
      }),
    ]).then(function () {
      jsFlash(_('Copied to clipboard'), 'success');
    }, function () {
      throw 'Error copying to clipboard';
    });
  } catch (err) {
    $.getJSON(url, function (data) {
      if (data == null) {
        jsFlash(_('Error'), 'danger');
        return;
      }

      var el = document.createElement('textarea');

      el.value = data.key;
      document.body.appendChild(el);

      el.select();

      document.execCommand('copy');
      document.body.removeChild(el);

      jsFlash(_('Copied to clipboard'), 'success');
    });
  }
}

function getTrace(url, element) {
  if (element) {
    var target = $(element).data('target');
    var dataHide = $(element).data('hide');

    $(dataHide).hide();
    $(target).show();

    var actions = `<div class="action-container">
    <div class="btn-group">
        <button class="btn btn-default"
                style="margin-bottom:10px"
                id="trace-back-btn"
                onclick="traceBack('${target}', '${dataHide}')">
            <i class="nsicon nsicon-reply"></i> ${_('Back')}
        </button>
        <button class="btn btn-default"
                style="margin-bottom:10px"
                id="trace-share-btn"
                onclick="saveTrace('${url}')"><i class="fa fa-share-square-o"></i> ${_('Share')}
        </button>
    </div>
</div>
<div class="loading-container" style="position: initial; margin-top: 60px">
    <div class="loading-spinner la-ball-spin-clockwise">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>`;

    $(target).append(actions);

    $.getJSON(url, function (data) {
      $(target).find('.loading-container').remove();

      if (data == null) {
        var noTrace = `<div class="nonecreated"><h3>${_('No trace available')}</h3></div>`;

        $(target).append(noTrace);
      } else if (data.svg != null) {
        var svg = atob(data.svg);
        var $target = document.querySelector(target);

        $target.innerHTML += `<div class="flow-fullscreen-container">${svg}</div>`;

        Array.from($target.querySelectorAll('script')).forEach(function (scriptTag) {
          var newScriptTag = document.createElement('script');

          Array.from(scriptTag.attributes).forEach(function (attr) {
            if (attr.name.includes('xml')) {
              return;
            }

            if (attr.name == 'xlink:href') {
              newScriptTag.src = attr.value;
            }

            newScriptTag.setAttribute(attr.name, attr.value);
          });

          if (scriptTag.textContent) {
            newScriptTag.textContent = scriptTag.textContent;
          } else if (scriptTag.innerText) {
            newScriptTag.innerText = scriptTag.innerText;
          }

          scriptTag.parentNode.replaceChild(newScriptTag, scriptTag);
        });
      }
    });

    return false;
  }

  $.getJSON(url)
    .done(function (data) {
      var modalObj = $('#history-trace');

      log(data);

      if (data.url) {
        // There is only one server that handled the call, so NS Flow returns a single URL to load HTML from
        loadModal('#history-trace', data.url);

        return;
      }

      modalObj.css('minHeight', modalObj.height() + 'px');

      var imageSources = [];
      var tabsHtml = '';
      var tabPanesHtml = '';
      var footerButtons = '';

      Object.keys(data).forEach(function (key, index) {
        var tabId = key.replace(/\W/g, '');
        var rawUrl = data[key].replace('/modal.php', '');
        var imgSrc = data[key].replace('modal.php', 'callflow.svg');
        var fullTraceHref;

        imageSources.push(imgSrc);

        tabsHtml += `<li${index === 0 ? ' class="active"' : ''}>
    <a href="#${tabId}" data-rawurl="${rawUrl}" data-toggle="tab">${key}</a>
</li>`;

        tabPanesHtml += `<div class="tab-pane${index === 0 ? ' active' : ''}" id="${tabId}">
    <div class="callflow-image">
        <img src="${imgSrc}" id="${tabId}img" />
    </div>
</div>`;

        if (index === 0) {
          fullTraceHref = `${rawUrl}/index_with_frames.html`;
          footerButtons += `<a id="dnlLink" class="btn btn-default" href="${rawUrl}.csv" target="_blank">${_('Download CSV')}</a>
<a id="viewLink" class="btn btn-default" href="${fullTraceHref}" target="_blank">${_('View Full Trace')}</a> `;
        }
      });

      var html = `<div class="modal-header">
    <button type="button"
            class="close cancel"
            data-dismiss="modal"
            aria-hidden="true"
            onclick="hideModal('#history-trace');">&times;
    </button>
    <h4>${_('Call Trace')}</h4>
</div>
<div class="modal-body">
    <ul id="serverTabs" class="nav nav-tabs">
        ${tabsHtml}
    </ul>
    <div class="tab-content">
        ${tabPanesHtml}
    </div>
</div>
<div class="modal-footer">
    ${footerButtons}
    <button class="btn btn-default cancel"
            data-dismiss="modal"
            aria-hidden="true"
            onclick="hideModal('#history-trace');">${_('Close')}
    </button>
</div>
<script type="text/javascript">
    $('#serverTabs a').on('click', function (e) {
        e.preventDefault();
        $(this).tab('show');
        $('#dnlLink').attr('href', $(this).data('rawurl') + '.csv');
        $('#viewLink').attr('href', $(this).data('rawurl') + '/index_with_frames.html');
    });
</script>`;

      resizeTraceModal(modalObj, imageSources);

      modalObj.find('.modal-content').html(html);

      modalObj.find('.modal-body')
        .css('minHeight', '90px')
        .animate({
          height: 'show',
          opacity: 'show',
        }, { duration: 250 });
    })
    .fail(function (jqxhr) {
      var modalObj = $('#history-trace');

      modalObj.css('minHeight', `${modalObj.height()}px`);

      try {
        modalObj.html(
          `<div class="modal-dialog" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('#history-trace');">&times;
            </button>
            <h4>${_('Call Trace')}</h4>
        </div>
        <div class="modal-body">
            <div class="nonecreated"><h3>${jqxhr.responseJSON.message}</h3></div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('#history-trace');">${_('Close')}
            </button>
        </div>
    </div>
</div>`,
        );
      } catch (err) {
        log(err);
      }

      modalObj.find('.modal-body')
        .css('minHeight', '90px')
        .animate({
          height: 'show',
          opacity: 'show',
        }, { duration: 250 });
    });
}

function getCradle(url, element) {
  if (!element) {
    return;
  }

  var target = $(element).data('target');
  var toHide = document.querySelectorAll($(element).data('hide'));

  for (var i = 0; i < toHide.length; i += 1) {
    toHide[i].style.display = 'none';
  }

  $(target).addClass('loading fade in');

  if (document.querySelector(target).classList.contains('modal')) {
    $(target).modal('show');

    $(target).animate({
      height: 'show',
      opacity: 1,
    }, {
      progress: function () {
        modalResize($(target));
      },
      complete: function () {
        modalResize($(target));
      },
    });
  } else {
    $(target).modal('show');

    var actions = `<button class="btn btn-default"
        style="margin-bottom: 10px;"
        id="trace-back-btn"
        onclick="traceBack('${target}','${$(element)
  .data('hide')}')"><i class="nsicon nsicon-reply"></i> ${_('Back')}
</button>
<div class="loading-container" style="position: initial; margin-top: 60px;">
    <div class="loading-spinner la-ball-spin-clockwise">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>`;

    $(target).append(actions);
  }

  $.getJSON(url)
    .done(function (events) {
      $(target).removeClass('loading');
      $(target).find('.loading-container').remove();

      if (document.querySelector(target).classList.contains('modal')) {
        var traceClass = (subScope === 'Super User' || subScope === 'Reseller') ? '' : 'hidden';

        $(target).find('.modal-dialog').html(`<div class="modal-content">
    <div class="modal-header">
        <button type="button"
                class="close cancel"
                data-dismiss="modal"
                aria-hidden="true"
                onclick="hideModal('${target}');">
            &times;
        </button>
        <h4>${portalCradleToGraveFeatureName}</h4></div>
    <div class="modal-body"></div>
    <div class="modal-footer">
        <button class="btn btn-default ${traceClass}"
                data-target="#trace-inline"
                data-tooltip-container=".action-buttons-inner"
                data-hide=".nav-tabs, .action-container, .callhistory-panel-main, .cc-report-details-container"
                onclick="hideModal('${target}'); $('div.cc-report-details-container').hide(); getTrace('${url.replace('cradle', 'trace')}', this); return false;">
            ${_('View SIP Flow')}
        </button>
        <button class="btn btn-default cancel" data-dismiss="modal" aria-hidden="true" onclick="hideModal('${target}');">
            ${_('Close')}
        </button>
    </div>
</div>`);
      }

      if (events == null || events.length === 0) {
        var noTrace = '<div class="nonecreated"><h3>' + _('No trace available') + '</h3></div>';
        $(target).find('.modal-body').html(noTrace);
      }

      var timelineList = $('<ul class="cradle-timeline">');

      events.forEach(function (event) {
        var eventClass = event.hasOwnProperty('classes') ? 'event ' + event.classes : 'event';
        var listItem = $(`<li class="${eventClass}" data-date="${event.ts}">`);

        if (event.diff_ts.length > 0) {
          listItem.append(`<span class="event-ts">+${event.diff_ts}</span>`);
        }

        listItem.append('<p>' + event.str + '</p>');
        timelineList.append(listItem);
      });

      $(target).find('.modal-body').html(timelineList);

      if (document.querySelector(target).classList.contains('modal') || $(target)
        .parent('.modal').length > 0) {
        modalResize($(target).parent('.modal'));
      }
    })
    .fail(function () {
      var noTrace = '<div class="nonecreated"><h3>' + _('No trace available') + '</h3></div>';

      $(target).find('.modal-body').html(noTrace);
    });
}

function propagateTabTrace(mdlName, url) {
  var modalObj = $('#' + mdlName);
  var modalId = modalObj.id;

  $.ajax({
    url: url,
    cache: false,
  })
    .done(function (html) {
      try {
        modalObj.css('minHeight', '600px');
        modalObj.empty();

        modalObj.append(html);
      } catch (err) {
        log(err, true);
      }
    })
    .fail(function (textStatus) {
      modalObj.removeClass('loading').addClass('load-failed');

      var html = `<div class="modal-dialog" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('${modalId}');">
                &times;
            </button>
            <h4>${textStatus.statusText}</h4>
        </div>
        <div class="modal-body">
            <div class="load-failed">
                <h4>${_('Contents failed to load.')}</h4>
                <h4>${_('Please try again.')}</h4>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="cancel btn btn-default" data-dismiss="modal" onclick="hideModal('${modalId}');">
                ${_('Close')}
            </button>
        </div>
    </div>
</div>`;

      modalObj.html(html);
      modalObj.find('.modal-header, .modal-body, .modal-footer').show();
    });
}

function cleanRemote(str) {
  if (str == null) {
    return '';
  }

  str = str.replace('sip', '');
  str = str.replace(':', '');
  str = str.replace('+', '');
  str = str.replace('(', '');
  str = str.replace(')', '');
  str = str.replace('-', '');
  str = str.replace(/\./g, '');
  str = str.replace(/:/g, '');
  str = str.replace(/ /g, '');
  str = str.replace(/\+/g, '');
  str = str.replace(/\(/g, '');
  str = str.replace(/\)/g, '');
  str = str.replace(/-/g, '');
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.replace(/\[/g, '');
  str = str.replace(/]/g, '');
  str = str.replace(/"/g, '');
  str = str.replace(new RegExp('@' + subDomain, 'g'), '');

  return str;
}

/**
 * Returns a formatted NA number
 *
 * @param {string} str
 *
 * @returns {string}
 */
function cleanTermQueue(str) {
  var res = str.split('@');

  return res[0];
}

function clickToDial(user, formatted, destination, origination, autoanswer) {
  if (typeof origination !== 'undefined' && origination != null) {
    origination = '/' + origination;
  } else {
    origination = '';
  }

  if (typeof autoanswer === 'undefined' || autoanswer === null) {
    autoanswer = false;
  }

  formatted = cleanDevice(formatted);

  destination = destination.replace('+', 'PLUS');

  if (autoanswer) {
    $.post(
      '/portal/calls/clickToDialAA/' + user + '/' + destination + origination,
      function (data) {
        if (data.trim() == 'ok') {
          jsFlash(_(
            'Please answer your ringing phone and the call will be connected to {0}',
            formatted,
          ), 'success');
        } else {
          jsFlash(_('There was an error placing your call to {0}', formatted), 'danger');
        }
      },
    );
  } else {
    $.post('/portal/calls/clickToDial/' + user + '/' + destination + origination, function (data) {
      if (data.trim() == 'ok') {
        jsFlash(_(
          'Please answer your ringing phone and the call will be connected to {0}',
          formatted,
        ), 'success');
      } else {
        jsFlash(_('There was an error placing your call to {0}', formatted), 'danger');
      }
    });
  }
}

function clickToAddParticipant(bridge, destination) {
  $.post('/portal/conferences/clickToDial/' + bridge + '/' + destination, function (data) {
    if (data.trim() == 'ok') {
      jsFlash(_('A call to {0} has been initiated', destination), 'success');
    } else {
      jsFlash(_('There was an error placing the call to {0}', destination), 'danger');
    }
  });
}

// itm is the mute button that was pressed
function muteParticipant($element) {
  var $row = $element.closest('tr');
  var bridge = $row.data('conference-id');
  var destination = $row.data('participant-id');

  $.post(`/portal/conferences/mute/${bridge}/${destination}`, function (data) {
    log(data);

    $('.helpsy').tooltip('hide');

    if (data.trim() != 'ok') {
      jsFlash('Participant could not be muted!', 'danger');

      return;
    }

    jsFlash('Participant muted!', 'success');

    $element.data('title', _('Unmute'))
      .attr('onclick', 'unmute($(this))');

    $row.find('td.participant-mode')
      .html(`<span class="label label-success">${_('Active')}</span>`);

    initTooltips();
  });
}

function unmuteParticipant($element) {
  var $row = $element.closest('tr');
  var bridge = $row.data('conference-id');
  var destination = $row.data('participant-id');

  $.post(`/portal/conferences/unmute/${bridge}/${destination}`, function (data) {
    log(data);

    $('.helpsy').tooltip('hide');

    if (data.trim() != 'ok') {
      jsFlash('Participant could not be unmuted!', 'danger');

      return;
    }

    jsFlash('Participant unmuted!', 'success');

    $element.data('title', _('Mute'))
      .attr('onclick', 'mute($(this))');

    $row.find('td.participant-mode')
      .html(`<span class="label label-danger">${_('Muted')}</span>`);

    initTooltips();
  });
}

function discParticipant($element) {
  var $row = $element.closest('tr');
  var bridge = $row.data('conference-id');
  var destination = $row.data('participant-id');

  $.post(`/portal/conferences/disc/${bridge}/${destination}`, function (data) {
    log(data);

    $('.helpsy').tooltip('hide');

    if (data.trim() == 'ok') {
      jsFlash('Participant disconnected!', 'success');
    } else {
      jsFlash('Participant not disconnected!', 'danger');
    }
  });
}

// updates tabs voicemail count badge
function handleRecentSessionCount(count) {
  var $recentUnreadBadge = $('#recents-msg-count');

  if ($recentUnreadBadge.length) {
    if (count > 0) {
      $recentUnreadBadge.text(count).fadeIn();
    } else {
      $recentUnreadBadge.fadeOut();
    }
  }
}

// gets the messages count of voicemails and sms/chat (if enabled)
function getRecentCount() {
  $.ajax({ url: '/portal/messages/countUnreadRecents/', timeout: 30000 }).done(function (data) {
    var chatMsg = 0;

    if (enableChatUC || enableChatSMS) {
      if (data && typeof data !== 'undefined' && $.isNumeric(data)) {
        chatMsg = data;
      }

      handleRecentSessionCount(chatMsg);
    }
  }).fail(function () {
    log('Failed to load unread recents count');
  });
}

// updates messages count badge
function handleMsgCount(count) {
  var $badge;

  if ($('#nav-msg-count').length) {
    $badge = $('#nav-msg-count');
  } else if ($('.dropdown-msg-count').length) {
    $badge = $('.dropdown-msg-count');
  } else {
    return;
  }

  if (count > 0) {
    $badge.text(count).fadeIn();
  } else {
    $badge.fadeOut();
  }
}

// updates tabs chat/sms count badge
function handleMsgCountChatSMS(count) {
  if (count > 0) {
    $('#sub-nav-msg-count').text(count)
      .fadeIn();
  } else {
    $('#sub-nav-msg-count').fadeOut();
  }
}

// updates tabs voicemail count badge
function handleMsgCountChatVM(count) {
  if (count > 0) {
    $('#sub-nav-vm-count').text(count)
      .fadeIn();
  } else {
    $('#sub-nav-vm-count').fadeOut();
  }
}

// gets the messages count of voicemails and sms/chat (if enabled)
// and renew AccessToken
function getCount() {
  var options = {
    domain: subDomain,
    type: 'queue',
  };

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscribeOnce(options);
    });

  $.ajax({ url: '/portal/voicemails/count/', timeout: 30000 }).done(function (vmMsg) {
    if (enableChatUC || enableChatSMS) {
      // get unread sms/chat messages if enabled
      var args = {
        action: 'count',
        object: 'messagesession',
        format: 'json',
        user: subUser,
        domain: subDomain,
        last_sender: 'remote',
        last_status: 'unread',
        muted: 'no',
      };

      netsapiens.api.post(args, function (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }

        var chatMsg = 0;
        var totalMsg;

        if (data && typeof data.total !== 'undefined' && $.isNumeric(data.total)) {
          chatMsg = data.total;
        } else if (data && typeof data === 'number') {
          chatMsg = data;
        }

        // update tab badges if they exist
        if ($('#sub-nav-msg-count').length) {
          handleMsgCountChatSMS(chatMsg);
          handleMsgCountChatVM(vmMsg);
        } else {
          // else just update the main messages badges
          totalMsg = chatMsg + parseInt(vmMsg, 10);
          handleMsgCount(totalMsg);
        }
      });
    } else {
      // just use voicemail count
      handleMsgCount(vmMsg);
    }
  }).fail(function () {
    log('Failed to load voicemail count');
  });
}

function minusOneVmail() {
  var count = $('#nav-msg-count').text();

  count -= 1;
  handleMsgCount(count);
}

function clearAutoComplete(id) {
  var choices = [];

  $('#' + id).autocomplete({
    source: function (request, response) {
      var results = $.ui.autocomplete.filter(choices, request.term);

      response(results);
    },
  });
}

/**
 * Domain was chosen, so should change the list of the users that are available for autofill
 *
 */
function cdrScheduleChangeDomain() {
  $('#user-choices').val('');

  clearAutoComplete('user-choices');
}

/**
 * Reseller was chosen, so should change the list of the domains that are available for autofill
 *
 */
function cdrScheduleChangeReseller() {
  $('#domain-choices').val('');
  $('#user-choices').val('');

  clearAutoComplete('domain-choices');
  clearAutoComplete('user-choices');
}

function brandingChangeDomain(event, ui) {
  var value = (ui.item.id || '').split(' ')[0];

  $('#domain').val(value);
  $('#domain_select').val(value);

  $('#user')
    .find('select')
    .trigger('change');
}

function domainChangeDomain(event, ui) {
  $('#domain').val(ui.item.id);
}

function brandingChangeDomainUser(event, ui) {
  $('#user').val(ui.item.id);
}

function changeDomainUser(event, ui) {
  $('#user').val(ui.item.id);
}

function inventoryChangeDomain() {
  if (notesClear) {
    $('#notes').val('');
  }

  $('#PhonenumberApplication').val('available');
  $('#PhonenumberApplication').trigger('change');
  $('#trunk-choices-dd').data('domain', '');
  $('#route-choices-dd').data('domain', '');
  $('#user-choices').val('');
  $('#fax-choices').val('');
  $('#conference-choices').val('');
  $('#callqueue-choices').val('');
  $('#vmail-choices').val('');
  $('#PhonenumberNumber').val('');

  clearAutoComplete('user-choices');
  clearAutoComplete('fax-choices');
  clearAutoComplete('conference-choices');
  clearAutoComplete('callqueue-choices');
  clearAutoComplete('vmail-choices');
  clearAutoComplete('attendant-choices');
}

function answerrulesFeatureCheck() {
  // minfeature
}

function updateExportHref() {
  var path = '/portal/contacts/export/' + encodeURIComponent($('#ContactContacts').val())
    + '/' + $('#ContactFormat').val() + '/contacts.';
  var format = $('#ContactFormat').val() + '';

  if (format == 'vcard') {
    path += 'vcf';
  } else {
    path += 'csv';
  }

  $('#export_button').attr('href', path);
}

// update the path the export button will take to make sure it is in the
// export_shared_contacts function instead of looking at the regular export subset
function updateExportHrefShared() {
  var path = '/portal/contacts/export_shared_contacts/'
    + encodeURIComponent($('#ContactContacts').val())
    + '/' + $('#ContactFormat').val() + '/contacts.';
  var format = $('#ContactFormat').val() + '';

  if (format == 'vcard') {
    path += 'vcf';
  } else {
    path += 'csv';
  }

  $('#export_button').attr('href', path);
}

function pad(num) {
  return ('0' + num).slice(-2);
}

function getSecDiffUtc(date) {
  var startTime = moment.utc(date);

  if (typeof startTime === 'undefined' || startTime == 'Invalid Date' || startTime == 'NaN') {
    startTime = moment(startTime, 'yyyy-MM-ddd hh:mm:ss zzz');
  }

  return moment().diff(startTime, 'seconds');
}

function getMMss(sec) {
  var hour = Math.floor(sec / 3600);

  sec -= (hour * 3600);

  var min = Math.floor(sec / 60);

  sec -= (min * 60);
  sec = Math.floor(sec);

  var duration = '';

  if (hour > 0) {
    duration += pad(hour) + ':';
  }

  duration += pad(min) + ':';
  duration += pad(sec);

  return duration;
}

function getDuration(date, offset) {
  var sec = getSecDiffUtc(date);

  if ((sec - offset) >= 0) {
    sec -= offset;
  }

  return getMMss(sec);
}

function changehidden(event, ui, avail, hidden) {
  if (typeof ui === 'undefined') {
    return;
  }

  var selectedObj = ui.item;
  var device = '';

  $('#' + avail + ' option').each(function () {
    if (selectedObj.value == this.value || selectedObj.value == this.innerHTML) {
      device = this.text;
    }
  });

  var $hiddenElement = $('#' + hidden);

  $hiddenElement.val(device);

  if (device === '' && selectedObj.value.includes('@conference-bridge')) {
    $hiddenElement.val(selectedObj.value);
  }
}

function changeDispType() {
  var disp = $('#CallhistoryDisposition');
  var reason = $('#CallhistoryReason');
  var dispValue = disp.val().toString();

  reason.empty();

  var matchString = '#disposition-' + dispValue.replace(/ /g, '') + ' > option';

  $(matchString).each(function () {
    reason.append('<option>' + this.value + '</option>');
  });
}

function isNumber(n) {
  // eslint-disable-next-line no-restricted-globals
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function postLog(status) {
  $.post('/portal/agents/agentLog/' + status, $.noop)
    .fail(function () {
      log('postLog: ' + status + ' failed');
    })
    .done(function () {
      log('postLog: ' + status + ' success');
    });
}

function callToOwn(device, callid) {
  $.post('/portal/phones/own/' + device + '/' + callid, function (data) {
    if (data.trim() != 'ok') {
      jsFlash('There was an error placing your call to ' + device, 'danger');

      return;
    }

    jsFlash('Please answer the ringing phone (' + device + ')', 'success');

    $('#activate-done').on('click', function () {
      // if on the agents page
      if ($('.phones-panel-home').length > 0) {
        NsAgentsMain.hotDeskConfirm(device);
      } else {
        // if on the phones page
        location.reload(true);
      }
    });
  })
    .always(function () {
      $('#activateCallBtn').prop('disabled', false);
    });
}

function ownDevice(callid) {
  var device = $('#device').val();
  var devSplit = device.split(' ');

  log(devSplit[0]);
  callToOwn(devSplit[0], callid);
  $('#activateCallBtn').prop('disabled', true);
}

function toggleHiddenUser() {
  NsCookies.setUserHidden($('#hideSystemUsers').is(':checked'));
  // eslint-disable-next-line no-restricted-globals
  location.reload();
}

function releaseDevice(device, queue) {
  var url = '/portal/phones/release/' + device;

  if (typeof queue !== 'undefined' && queue != '') {
    url = url + '/' + queue;
  }

  $.post(url, function (data) {
    if (data.trim() == 'ok') {
      jsFlash('The phone (' + device + ') has been released ', 'success');
    } else {
      jsFlash('There was an error releasing phone ' + device, 'danger');
    }

    if (Cookies.get('agent-device') == device) {
      Cookies.set('agent-device', null);
    }

    setTimeout(function () {
      if ($('.phones-panel-home').length > 0) {
        NsAgentsMain.homeGetPhones();
      } else {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }, 1000);
  });
}

function routeTypeChange() {
  var type = $('#route_type_dd').val();

  log(type);

  if (type == 'percentage') {
    $('.pct-remaining, #pct-equal-btn')
      .animate({
        opacity: 'show',
        width: 'show',
      });

    $('.trunk-method-table').animate(
      { opacity: 'hide' },
      {
        queue: true,
        duration: 200,
        complete: function () {
          $('.route-fixed').hide();
          $('.route-percent').show();
        },
      },
    );

    $('.trunk-method-table')
      .animate({
        opacity: 'show',
        queue: true,
      });
  } else if (type == 'fixed') {
    $('.pct-remaining, #pct-equal-btn')
      .animate({
        opacity: 'hide',
        width: 'hide',
      });

    $('.trunk-method-table').animate(
      { opacity: 'hide' },
      {
        queue: true,
        duration: 200,
        complete: function () {
          $('.route-percent').hide();
          $('.route-fixed').show();
        },
      },
    );

    $('.trunk-method-table')
      .animate({
        opacity: 'show',
        queue: true,
      });
  }
}

function trunkTypeChange() {
  if ($('#trunk_type_dd').val() === 'origination-only' || $('#trunk_type_dd').val() === 'locked') {
    $('.outbound-only')
      .animate({
        height: 'hide',
        opacity: 'hide',
      });
  } else {
    $('.outbound-only')
      .animate({
        height: 'show',
        opacity: 'show',
      });
  }

  if ($('#isAdd').length != 0) {
    return;
  }

  if ($('#trunk_type_dd').val() === 'termination-only' || $('#trunk_type_dd').val() === 'locked') {
    $('.inbound-only')
      .animate({
        height: 'hide',
        opacity: 'hide',
      });
  } else {
    $('.inbound-only')
      .animate({
        height: 'show',
        opacity: 'show',
      });
  }
}

function authChange() {
  if ($('#auth_dd').val() == 'yes') {
    $('#authEnabledSection')
      .animate({
        height: 'show',
        opacity: 'show',
      });
  } else {
    $('#authEnabledSection')
      .animate({
        height: 'hide',
        opacity: 'hide',
      });
  }
}

function addRecentDomain(domain, desc) {
  var domains = [];
  var ns = Storages.initNamespaceStorage(subUser + subDomain);
  var storage = ns.localStorage;

  desc = desc.trim();
  domain = domain.trim();

  if (storage.isSet('domains')) {
    domains = storage.get('domains');
  }

  var storedValue = `${domain}|||${desc}`;
  var existingIndex = domains.indexOf(storedValue);

  if (existingIndex > -1) {
    domains.splice(existingIndex, 1);
  }

  domains.unshift(storedValue);

  domains = domains.slice(0, 10);
  storage.set('domains', domains);
}

function updateRecentDomain(domain, desc) {
  var newDesc = desc.replace(domain, '').trim();

  newDesc = newDesc.replace('(', '').trim();
  newDesc = newDesc.replace(')', '').trim();

  if (newDesc == domain) {
    newDesc = '';
  }

  log(desc);
  addRecentDomain(domain, newDesc);
}

function removeRecentDomain(domainToRemove) {
  var domains = [];
  var ns = Storages.initNamespaceStorage(subUser + subDomain);
  var storage = ns.localStorage;

  domainToRemove = domainToRemove.trim();

  if (storage.isSet('domains')) {
    domains = storage.get('domains');
  }

  var existingIndex;

  domains.forEach(function (domain, index) {
    if (domain.split('|||')[0] === domainToRemove) {
      existingIndex = index;
    }
  });

  if (existingIndex) {
    domains.splice(existingIndex, 1);
  }

  storage.set('domains', domains);

  return true;
}

function modifyDialPlanForDomain(domain) {
  $('#staticdomain').text(domain);

  $.getJSON('/portal/sip_trunks/dialPlanLookup/' + domain, function (data) {
    log(data);

    $('#dialplan').empty();
    $('#dialplan').append('<option value="">Please select a Dial Translation</option>');

    $.each(data.plans, function (key, val) {
      var selected = '';

      if (domain == val) {
        selected = 'selected="selected"';
      }

      $('#dialplan').append('<option value="' + val + '"' + selected + '>' + val + '</option>');
    });

    $('#dialpolicy').empty();
    $('#dialpolicy').append('<option value="">Please select a Dial Permission</option>');

    $.each(data.policies, function (key, val) {
      $('#dialpolicy').append('<option value="' + val + '">' + val + '</option>');
    });

    $('#dialplanningSection').show();
  });
}

function modifyDialPlanning(event, ui) {
  var domain = ui.item.id;

  modifyDialPlanForDomain(domain);
}

function inventoryMacDomainChange(event, ui, domain) {
  var i;
  var id;

  if (typeof domain === 'undefined' || domain == null) {
    domain = ui.item.id;
  }

  var a = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
  ];

  if (typeof lineCountDynamic === 'undefined') {
    window.lineCountDynamic = 3;
  }

  $('#staticdomain').text(domain);

  for (i = 0; i < a.length; i += 1) {
    id = '#line' + a[i];

    $(id).val('');
    $(id).prop('disabled', true);

    if (i <= window.lineCountDynamic) {
      $('#device_linerow_' + a[i]).show();
    }
  }

  try {
    $.getJSON('/portal/phones/getDevices/' + domain, function (data) {
      if (data == null) {
        return;
      }

      log(data);

      var choices = [];

      $.each(data, function (key, val) {
        choices.push({
          id: key,
          value: val,
        });
      });

      for (i = 0; i < a.length; i += 1) {
        id = '#line' + a[i];

        $(id).autocomplete({
          autoFocus: true,
          source: function (request, response) {
            var results = $.ui.autocomplete.filter(choices, request.term);

            if (!results.length) {
              $(id).validationEngine(
                'showPrompt',
                _('* No matches found!'),
                'red',
                'bottomLeft',
                true,
              );
            } else {
              $(id).validationEngine('hide');
            }

            response(results);
          },
        });

        $(id).prop('disabled', false);
      }
    });
  } catch (e) {
    log(e);
  }
}

function cleanId(value) {
  var val = '';

  if (typeof value !== 'undefined') {
    val = value.replace(/\W/g, '-');
  }

  return val;
}

function removeSpecials(str) {
  var lower = str.toLowerCase();
  var upper = str.toUpperCase();

  var res = '';

  // eslint-disable-next-line no-plusplus
  for (var i = 0; i < lower.length; ++i) {
    if (lower[i] != upper[i] || '0123456789'.indexOf(lower[i]) !== -1) {
      res += str[i];
    }
  }

  return res;
}

function addAutoCleanFunction() {
  $('.autoclean').on('change', function () {
    var cleanValue = removeSpecials($(this).val());

    $(this).val(cleanValue);
  });
}

function addIEsupport() {
  if (!jQuery.support.cors && window.XDomainRequest) {
    var httpRegEx = /^https?:\/\//i;
    var getOrPostRegEx = /^get|post$/i;
    // eslint-disable-next-line no-restricted-globals
    var sameSchemeRegEx = new RegExp('^' + location.protocol, 'i');

    // ajaxTransport exists in jQuery 1.5+
    jQuery.ajaxTransport('xml json', function (options, userOptions) {
      // XDomainRequests must be: asynchronous, GET or POST methods, HTTP or HTTPS protocol,
      // and same scheme as calling page

      if (options.crossDomain) {
        log('options.crossDomain');
      }

      if (options.async) {
        log('options.async');
      }

      if (getOrPostRegEx.test(options.type)) {
        log('getOrPostRegEx.test(options.type)');
      }

      if (httpRegEx.test(userOptions.url)) {
        log('httpRegEx.test(userOptions.url)');
      }

      if (sameSchemeRegEx.test(userOptions.url)) {
        log('sameSchemeRegEx.test(userOptions.url)');
      }

      if (options.crossDomain
        && options.async
        && getOrPostRegEx.test(options.type)
        && httpRegEx.test(userOptions.url)
      ) {
        var xdr = null;
        var userType = (userOptions.dataType || '').toLowerCase();

        log('userType=' + userType);

        return {
          send: function (headers, complete) {
            xdr = new XDomainRequest();

            if (/^\d+$/.test(userOptions.timeout)) {
              xdr.timeout = userOptions.timeout;
              log('xdr.timeout=' + xdr.timeout);
            }

            xdr.ontimeout = function () {
              complete(90000, 'timeout');
            };

            xdr.onload = function () {
              var allResponseHeaders = 'Content-Length: '
                + xdr.responseText.length
                + '\r\nContent-Type: '
                + xdr.contentType;

              log('allResponseHeaders' + allResponseHeaders);

              var status = {
                code: 200,
                message: 'success',
              };

              var responses = {
                text: xdr.responseText,
              };

              try {
                if (userType === 'json') {
                  log('xdr.timeout=' + xdr.timeout);

                  try {
                    responses.json = JSON.parse(xdr.responseText);
                  } catch (e) {
                    log('status.message=parseerror');
                    status.code = 500;
                    status.message = 'parseerror';
                  }
                }
              } catch (parseMessage) {
                log('catch.parseMessage=' + parseMessage);
                throw parseMessage;
              } finally {
                complete(status.code, status.message, responses, allResponseHeaders);
              }
            };

            xdr.onerror = function () {
              log('xdr.responseText' + xdr.responseText);
              complete(500, 'error', { text: xdr.responseText });
            };

            xdr.open(options.type, options.url);
            xdr.send();
          },
          abort: function () {
            if (xdr) {
              xdr.abort();
            }
          },
        };
      }

      log('failed check');

      return null;
    });
  }
}

var BrowserDetect = {
  init: function () {
    this.browser = this.searchString(this.dataBrowser) || 'An unknown browser';
    this.version = this.searchVersion(navigator.userAgent)
      || this.searchVersion(navigator.appVersion)
      || 'an unknown version';
    this.OS = this.searchString(this.dataOS) || 'an unknown OS';
  },
  searchString: function (data) {
    for (var i = 0; i < data.length; i += 1) {
      var dataString = data[i].string;
      var dataProp = data[i].prop;

      this.versionSearchString = data[i].versionSearch || data[i].identity;

      if (dataString) {
        if (dataString.indexOf(data[i].subString) != -1) {
          return data[i].identity;
        }
      } else if (dataProp) {
        return data[i].identity;
      }
    }

    return null;
  },
  searchVersion: function (dataString) {
    var index = dataString.indexOf(this.versionSearchString);

    if (index == -1) {
      return null;
    }

    return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
  },
  dataBrowser: [
    {
      string: navigator.userAgent,
      subString: 'Chrome',
      identity: 'Chrome',
    },
    {
      string: navigator.userAgent,
      subString: 'OmniWeb',
      versionSearch: 'OmniWeb/',
      identity: 'OmniWeb',
    },
    {
      string: navigator.vendor,
      subString: 'Apple',
      identity: 'Safari',
      versionSearch: 'Version',
    },
    {
      prop: window.opera,
      identity: 'Opera',
      versionSearch: 'Version',
    },
    {
      string: navigator.vendor,
      subString: 'iCab',
      identity: 'iCab',
    },
    {
      string: navigator.vendor,
      subString: 'KDE',
      identity: 'Konqueror',
    },
    {
      string: navigator.userAgent,
      subString: 'Firefox',
      identity: 'Firefox',
    },
    {
      string: navigator.vendor,
      subString: 'Camino',
      identity: 'Camino',
    },
    {
      // for newer Netscapes (6+)
      string: navigator.userAgent,
      subString: 'Netscape',
      identity: 'Netscape',
    },
    {
      string: navigator.userAgent,
      subString: 'MSIE',
      identity: 'Explorer',
      versionSearch: 'MSIE',
    },
    {
      string: navigator.userAgent,
      subString: 'Gecko',
      identity: 'Mozilla',
      versionSearch: 'rv',
    },
    {
      // for older Netscapes (4-)
      string: navigator.userAgent,
      subString: 'Mozilla',
      identity: 'Netscape',
      versionSearch: 'Mozilla',
    },
  ],
  dataOS: [
    {
      string: navigator.platform,
      subString: 'Win',
      identity: 'Windows',
    },
    {
      string: navigator.platform,
      subString: 'Mac',
      identity: 'Mac',
    },
    {
      string: navigator.userAgent,
      subString: 'iPhone',
      identity: 'iPhone/iPod',
    },
    {
      string: navigator.platform,
      subString: 'Linux',
      identity: 'Linux',
    },
  ],
};

function dynamicCoverPageOptions() {
  var musicCoverOptionsSelect = $('#FaxCoverOptionsSelect').val();
  var coverTextGroup = $('.cover-text-group');
  var coverFileGroup = $('.cover-file-group');

  switch (musicCoverOptionsSelect) {
    case 'None':
      coverTextGroup.animate({
        height: 'hide',
        opacity: 'hide',
      });
      coverFileGroup.animate({
        height: 'hide',
        opacity: 'hide',
      });
      break;
    case 'File':
      coverTextGroup.animate({
        height: 'hide',
        opacity: 'hide',
      });
      coverFileGroup.animate({
        height: 'show',
        opacity: 'show',
      });
      break;
    case 'Compose':
      coverTextGroup.animate({
        height: 'show',
        opacity: 'show',
      });
      coverFileGroup.animate({
        height: 'hide',
        opacity: 'hide',
      });
      break;
    default:
  }
}

function selectLanguages(containerId, selectId, languages, selected) {
  var options = [];

  for (var i = 0; i < languages.length; i += 1) {
    // todo selected based on users lang
    var optionName = languages[i].name + ' (' + languages[i].country + ')';

    if (i === 0 && !selected) {
      options.push('<option value="' + languages[i].id + '" selected>' + optionName + '</option>');
    } else if (selected === languages[i].id) {
      options.push('<option value="' + languages[i].id + '" selected>' + optionName + '</option>');
    } else {
      options.push('<option value="' + languages[i].id + '">' + optionName + '</option>');
    }
  }

  var elem = $('#' + selectId);

  elem.empty();
  elem.append(options.join(''));

  if (options.length === 1) {
    $('#' + containerId).hide();
  }
}

function selectVoices(selectId, voices, selected) {
  var options = [];

  for (var i = 0; i < voices.length; i += 1) {
    if (i === 0 && !selected) {
      options.push('<option value="' + voices[i].id + '" selected>' + voices[i].name + '</option>');
    } else if (selected === voices[i].id) {
      options.push('<option value="' + voices[i].id + '" selected>' + voices[i].name + '</option>');
    } else {
      options.push('<option value="' + voices[i].id + '">' + voices[i].name + '</option>');
    }
  }

  var elem = $('#' + selectId);

  elem.empty();
  elem.append(options.join(''));
}

function formatVoiceLabel(voices) {
  var voiceEngines = [];

  voices.forEach(function (voice) {
    var key = voice.type + voice.subType;

    voiceEngines.push(key);
  });

  voiceEngines = voiceEngines.filter(function (value, index) {
    return voiceEngines.indexOf(value) === index;
  });

  // We won't add the voice engine info to the voice labels if there is only one engine enabled.
  if (voiceEngines.length <= 1) {
    return;
  }

  voices.forEach(function (voice) {
    var type = voice.type;
    var subType = voice.subType;

    if (type === 'watson') {
      voice.name += ' (IBM Watson)';
    } else if (type === 'google') {
      voice.name += subType === 'standard' ? ' (Google)' : ' (Google WaveNet)';
    } else if (type === 'azure') {
      voice.name += ' (Azure)';
    } else if (type === 'polly') {
      voice.name += ' (Polly)';
    }
  });
}

function handleGreetingTimeFrameSelect() {
  var content = $('#newGreetingTimeframeSelect')
    .find(':selected')
    .val();

  $('#save_button_js').prop('disabled', !content || !content.trim());
}

function initRecordingBtns(thisElement, numCols, audioTag, newHost) {
  var $listenBtn = thisElement.find('.listen-btn');
  var $downloadBtn = thisElement.find('.download-btn');

  $('.tooltip').hide();

  $listenBtn.prop('disabled', false);

  if (preferMp4) {
    thisElement.after(`<tr class="audioplayerrow cdraudio hidden">
    <td class="cdraudio" colspan="${numCols}">${audioTag}
        <source src="${newHost}&convert=aac" type="audio/aac">
        <source src="${newHost}&convert=aac" type="audio/mp4">
        <source src="${newHost}&convert=wav16" type="audio/wav">
        </audio>`);
  } else {
    thisElement.after(`<tr class="audioplayerrow cdraudio hidden">
    <td class="cdraudio" colspan="${numCols}">${audioTag}
        <source src="${newHost}&convert=wav16" type="audio/wav">
        <source src="${newHost}&convert=aac" type="audio/aac">
        <source src="${newHost}&convert=aac" type="audio/mp4">
        </audio>`);
  }

  initTooltips();
}

var voiceAuthentication = {};

/**
 * Authenticates with NetSapiens Voice once for the life of the page.
 * NetsapiensVoice.authenticate() requests a new token on every call and keeps
 * only the latest one, so the promise is reused until the user or domain
 * changes. A rejection is reused too, so a failure costs one request.
 */
function authenticateVoice(user, domain) {
  var key = `${user}@${domain}`;

  if (voiceAuthentication.key !== key) {
    voiceAuthentication = {
      key: key,
      promise: NetsapiensVoice.authenticate(user, domain),
    };
  }

  return voiceAuthentication.promise;
}

function lookupCall(jsURL, callback) {
  var user = subUser;
  var currDomain = subDomain;
  var newHost = currentServerName;

  $.getJSON(jsURL, function (data) {
    callback();

    $.each(data, function (callId, recording) {
      var geoId = recording.geo_id || 'n/a';
      var status = recording.status || '';

      $('#call-history-table > tbody > tr').each(function () {
        var $row = $(this);

        if ($row.data('state') == null) {
          $row.data('state', 'unknown');
        }

        // get number of columns by counting td children
        var numCols = $row.find('td').length;
        var origId = $row.data('orig-id');
        var termId = $row.data('term-id');
        var $actionButtonsGroup = $row.find('.action-buttons .btn-group');
        var $downloadBtn = $('<button class="btn btn-default btn-xs download-btn" data-container=".action-buttons-inner"><i class="fa fa-download"></i></button>');
        var $listenBtn = $('<button class="btn btn-default btn-xs listen-btn" data-container=".action-buttons-inner"><i class="fa fa-volume-up"></i></button>');

        if ($actionButtonsGroup.find('.listen-btn').length) {
          return;
        }

        $downloadBtn.attr('title', _('Download'));
        $listenBtn.attr('title', _('Listen'));

        if (callId !== origId && callId !== termId && geoId !== origId && geoId !== termId) {
          return;
        }

        var audioTag = `<audio class="cdraudio"
     controls
     controlslist="nodownload"
     data-orig-id="${origId}"
     data-term-id="${termId}"
     id="audio-${origId}"
     preload="${portalCallHistoryRecordingPreload}">`;

        if (status === 'converted' || status === 'archived') {
          if ($row.data('state') !== 'available') {
            var parser = document.createElement('a');

            parser.href = recording.url;

            newHost = $row.data('rec-domain') != null && $row.data('rec-domain') !== ''
              ? `${parser.protocol}//${$row.data('rec-domain')}${parser.pathname}${parser.search}`
              : recording.url.replace('/localhost', `/${newHost}`);

            if ($row.data('record-status-only')) {
              $listenBtn
                .prop('disabled', true)
                .attr('title', `${_('Recording Available')}. ${_('Playback Disabled')}.`);
            } else {
              authenticateVoice(user, currDomain).then(function () {
                var recordingDate = recording.time_open.substring(0, 7).replace('-', '');

                NetsapiensVoice.getTranscriptionJob({
                  callId: callId,
                  recordingDate: recordingDate,
                  user: user,
                  domain: currDomain,
                }).then(function (transcriptionJob) {
                  if (transcriptionJob && transcriptionJob.status === 'finished') {
                    $listenBtn
                      .addClass('open-transcription')
                      .on('click', function (event) {
                        event.preventDefault();
                        loadModal('#transcriptions', `/portal/callhistory/transcription/${transcriptionJob.id}/${recordingDate}/${encodeURIComponent(transcriptionJob.services)}/${btoa(origId)}/${btoa(termId)}`);
                      })
                      .attr('data-toggle', 'modal')
                      .attr('data-target', '#transcriptions');
                  } else {
                    initRecordingBtns($row, numCols, audioTag, newHost);
                  }

                  $downloadBtn.on('click', function (event) {
                    var downloadUrl = recording.url.replace('/localhost', currentServerName) + '&download=true';

                    event.preventDefault();
                    // setting window href to download file doesn't work in Acrobits desktop apps
                    // window.location.href = downloadUrl;
                    var downloadLink = document.createElement('a');
                    downloadLink.href = downloadUrl;
                    downloadLink.click();
                  });
                }).catch(function (err) {
                  console.error(err);

                  initRecordingBtns($row, numCols, audioTag, newHost);
                });
              }).catch(function (err) {
                console.error(err);

                initRecordingBtns($row, numCols, audioTag, newHost);
              });
            }

            $row.data('state', 'available');
          } else if ($row.data('record-status-only')) {
            var cdrAudioSourceHtml = preferMp4
              ? `<source src="${newHost}&convert=aac" type="audio/mp4">
  <source src="${newHost}&convert=wav16" type="audio/wav">`
              : `<source src="${newHost}&convert=wav16" type="audio/wav">
  <source src="${newHost}&convert=aac" type="audio/mp4">`;

            var cdrAudioHtml = `<td class="cdraudio" colspan="${numCols}">
  ${audioTag}>
  ${cdrAudioSourceHtml}
  </audio>`;

            $row.find('cdraudio').append(cdrAudioHtml);
          }
        } else if (status === 'unconverted') {
          $listenBtn
            .prop('disabled', true)
            .attr('title', _('Pending Conversion'));
        }

        if ($row.data('record-status-only')) {
          $actionButtonsGroup.prepend($listenBtn);
          $listenBtn.tooltip();
        } else if ($row.data('add-recording')) {
          if (status === 'converted' || status === 'archived') {
            $actionButtonsGroup.prepend($downloadBtn);
            $downloadBtn.tooltip();
          }

          $actionButtonsGroup.prepend($listenBtn);
          $listenBtn.tooltip();
        }
      });
    });
  });
}

setInterval(function () {
  if (!checkSessionTimeout) {
    checkSessionTimeout = setTimeout(function () {
      checkSession();
    }, 180000);
  }
}, 300000);

/** *****************************************************************************
 * document load
 *******************************************************************************
 */

/**
 * Sets up the widgets and element handlers in the page's markup. The ready
 * block runs it on page load, and a view injected into the page calls it once
 * its markup is in place. It works on the whole document, so markup already on
 * the page is set up again on each call.
 */
function initContent() {
  $('.date-field').each(function () {
    var widthClass = getFieldWidthClass(this, 80, 120);

    $(this).addClass(widthClass);
  });

  radioSlide();
  greetingFade();
  newDatePicker(0);
  dynamicDateField();
  attachValidation();
  initTooltips();
  initConfirmCall();
  initDownloadFile();

  log('adding DID application select events');

  $('#PhonenumberApplication').on('change', function () {
    var val = $(this).val();
    var isTimeFrame = false;

    if ($('#PhonenumberTimeframes').prop('checked')) {
      isTimeFrame = true;
    }

    if ($('div[id^="find-"]').is(':visible')) {
      if (isTimeFrame) {
        $('div[id^="find-"]:visible').hide();
      } else {
        $('div[id^="find-"]:visible').animate({
          opacity: 'hide',
        }, function () {
          if (!isTimeFrame) {
            $('#find-' + val).animate({ opacity: 'show' });
          }
        });
      }
    } else if (!isTimeFrame) {
      $('#find-' + val)
        .animate({
          height: 'show',
          opacity: 'show',
        });
    }

    if (isTimeFrame) {
      $('.treatmentBox').hide();

      $('.tzCapable')
        .animate({
          height: 'show',
          opacity: 'show',
        });
    } else {
      $('#app-details .tzCapable').hide();

      $('.tzCapable.panel')
        .animate({
          height: 'hide',
          opacity: 'hide',
        });

      $('.treatmentBox').fadeIn();
    }

    if ($(this).val() == 'trunk') {
      $('#trunk-choices').hide();
      $('#trunk-choices-dd').hide();

      if (($('#trunk-choices-dd option').length > 0)
        && ($('#trunk-choices-dd').data('domain') == $('#domain-choices').val())
      ) {
        $('#trunk-choices').show();
        $('#trunk-choices-dd').show();
      } else {
        log('looking up trunk');
        $('#trunk-choices').show();
        $('#trunk-choices').prop('disabled', true);
        $('#trunk-choices').val('Finding SIP Trunks....');

        $.getJSON('/portal/sip_trunks/listTrunks/' + $('#domain-choices').val(), function (data) {
          $('#trunk-choices').hide();
          $('#trunk-choices-dd').empty();
          $('#trunk-choices-dd').show();

          $('#trunk-choices-dd').append('<option value="">Please select SIP Trunk</option>');

          $.each(data.trunks, function (key, trunk) {
            var selected = '';

            $('#trunk-choices-dd')
              .append('<option value="' + trunk + '"' + selected + '>' + trunk + '</option>');
          });
        });
      }
    } else if ($(this).val() == 'route') {
      $('#route-choices').hide();
      $('#route-choices-dd').hide();

      if (($('#trunk-choices-dd').children('option').length > 0)
        && ($('#trunk-choices-dd').data('domain') == $('#domain-choices').val())
      ) {
        $('#route-choices').hide();
        $('#route-choices-dd').show();
      } else {
        log('looking up routes');
        $('#route-choices').show();
        $('#route-choices').prop('disabled', true);
        $('#route-choices').val('Finding Route Profiles....');

        $.getJSON(
          '/portal/routeprofiles/listTrunks/' + $('#domain-choices').val() + '',
          function (data) {
            $('#route-choices').hide();
            $('#route-choices-dd').empty();
            $('#route-choices-dd').show();

            $('#route-choices-dd').append('<option value="">Please select Route Profile</option>');

            $.each(data.trunks, function (key, trunk) {
              var selected = '';

              $('#route-choices-dd')
                .append('<option value="' + trunk + '"' + selected + '>' + trunk + '</option>');
            });
          },
        );
      }
    } else if ($(this).val() == 'user') {
      log($('#user-choices'));
      log($('#user-choices').length);
    }
  });

  // confirmation plugin calls (uses bootstrap popover)
  log('adding confirmation popovers');

  // confirmation popup with default options, best for hyperlink confirmation
  // add specific options via the data attribute
  // onConfirm cannote be set via the data attributes
  $('[data-toggle="confirmation"]').confirmation({
    rootSelector: '[data-toggle="confirmation"]',
    placement: 'left',
    btnOkClass: 'btn btn-sm btn-danger',
    btnCancelClass: 'btn btn-sm btn-default',
    singleton: true,
    popout: true,
    title: function () {
      var $self = $(this);

      return $self.data('confirmation-title') || $self.attr('title');
    },
  });

  // special case delete confirmation for aa greetings because of onConfirm
  // onConfirm grabs needed data from the originating button
  $('[data-toggle="aa-greeting-confirmation"]').confirmation({
    rootSelector: '[data-toggle="aa-greeting-confirmation"]',
    placement: 'left',
    href: 'javascript:void(0);',
    btnOkClass: 'btn btn-sm btn-danger aa-greeting-confirm',
    btnCancelClass: 'btn btn-sm btn-default',
    btnOkLabel: _('Yes', true),
    btnCancelLabel: _('No', true),
    singleton: true,
    popout: true,
    onConfirm: function () {
      var element = $(this);
      var rowId = $(element).data('row-id');
      var calleeMatch = $(element).data('callee-match');
      var starting = $(element).data('starting');
      var greetingIndex = $(element).data('greeting-index');
      var timeframe = $(element).data('timeframe');
      var rowElement = $(`#${rowId}`);

      jsFlash(_('Deleting...'), 'info');

      rowElement.css('opacity', '0.5');
      $(`#${rowId} .user-delete-btn, #${rowId} .edit`).hide();

      $.post(`./introDelete/${calleeMatch}/${starting}/${greetingIndex}/${timeframe}`)
        .done(function (data) {
          if (data.success) {
            loadIntroModal();

            jsFlash(_('Greeting has been deleted.'), 'success');

            if (data.redirect) {
              window.location.replace(data.redirect);
            }

            return;
          }

          rowElement.css('opacity', '1');
          rowElement.find('.aa-delete-btn').show();
          rowElement.find('.aa-edit-btn').show();

          jsFlash(_('Greeting was not deleted!'), 'danger');
        })
        .fail(function () {
          rowElement.css('opacity', '1');
          rowElement.find('.aa-delete-btn').show();
          rowElement.find('.aa-edit-btn').show();

          jsFlash(_('Greeting was not deleted!'), 'danger');
        });
    },
    title: function () {
      var $self = $(this);

      return $self.data('confirmation-title') || $self.attr('title');
    },
  });

  // special case delete confirmation for aa greetings because of onConfirm
  // onConfirm grabs needed data from the originating button
  $('[data-toggle="user-greeting-confirmation"]').confirmation({
    rootSelector: '[data-toggle="user-greeting-confirmation"]',
    placement: 'left',
    href: 'javascript:void(0);',
    btnOkClass: 'btn btn-sm btn-danger user-greeting-confirm',
    btnOkLabel: _('Yes', true),
    btnCancelLabel: _('No', true),
    btnCancelClass: 'btn btn-sm btn-default',
    singleton: true,
    popout: true,
    onConfirm: function () {
      var element = $(this);
      var rowId = $(element).data('row-id');
      var uid = $(element).data('uid');
      var greetingIndex = $(element).data('greeting-index');

      $(`#${rowId}`).css('opacity', '0.5');
      $(`#${rowId} .delete, #${rowId} .user-edit-btn`).hide();

      $.post(`./greetings/delete/${uid}/${greetingIndex}`, $.noop)
        .done(function () {
          $(`#${rowId}`).remove();
          jsFlash('Greeting has been deleted.', 'success');
        })
        .fail(function () {
          $(`#${rowId}`).css('opacity', '1');
          $(`#${rowId} .user-delete-btn, #${rowId} .user-edit-btn`).show();
          jsFlash(_('Greeting was not deleted') + '!', 'danger');
        });
    },
    title: function () {
      var $self = $(this);

      return $self.data('confirmation-title') || $self.attr('title');
    },
  });

  // informational popovers (uses bootstrap popover)
  log('adding popovers');

  if (typeof $('a.view-timeframe').popover === 'function') {
    $('a.view-timeframe').popover({
      trigger: 'hover',
      template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      sanitize: false,
      delay: {
        show: 200,
        hide: 0,
      },
      html: true,
    });
  }

  if (typeof $('a.view-qos').popover === 'function') {
    $('a.view-qos').popover({
      trigger: 'hover',
      template: '<div class="popover qos-popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      sanitize: false,
      delay: {
        show: 200,
        hide: 0,
      },
      html: true,
    });
  }

  if (typeof $('a.view-preview').popover === 'function') {
    $('a.view-preview').popover({
      trigger: 'hover',
      template: '<div class="popover faxpreview-popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      sanitize: false,
      delay: {
        show: 200,
        hide: 0,
      },
      html: true,
    });
  }

  if (typeof $('.label-popover').popover === 'function') {
    $('.label-popover').popover({
      trigger: 'hover',
      template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      container: 'body',
      html: true,
      sanitize: false,
      delay: {
        show: 200,
        hide: 0,
      },
    });
  }

  if (typeof $('.label-popover-scopes').popover === 'function') {
    $('.label-popover-scopes').popover({
      trigger: 'hover',
      template: `<div class="popover uiconfig">
    <div class="arrow"></div>
    <div class="popover-inner uiconfig">
        <h3 class="popover-title uiconfig"></h3>
        <div class="popover-content uiconfig"></div>
    </div>
</div>`,
      container: 'body',
      html: true,
      delay: {
        show: 200,
        hide: 100,
      },
      sanitize: false,
    });
  }

  if (typeof $('.clickable-popover').popover === 'function') {
    $('.clickable-popover').popover({
      trigger: 'click',
      template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      container: 'body',
      html: true,
      sanitize: false,
    });
  }

  log('adding table sorting for answering rules');

  // fixHelper keeps the dragged element from collapsing when dragging
  var fixHelper = function (e, ui) {
    ui.children().each(function () {
      $(this).width($(this).width());
    });

    return ui;
  };

  $('#sort-rules tbody').sortable({
    items: 'tr',
    helper: fixHelper,
    tolerance: 'pointer',
    placeholder: 'sort-placeholder',
    start: function (event, ui) {
      ui.placeholder.html('<td colspan="5" class="sort-placeholder-td">&nbsp;</td>');
      ui.placeholder.height(ui.helper.height());
    },
    update: function () {
      var ordering = $('#sort-rules tbody').sortable('toArray')
        .join('/');
      var action = 'reorder';

      if ($('#' + action).length) {
        var href = $('#' + action).attr('href');
        var base = href.substring(0, href.indexOf('/', href.indexOf(action) + action.length + 1));

        $('#' + action).attr('href', base + '/' + ordering);
        $('#save-priority')
          .animate({
            height: 'show',
            opacity: 'show',
          }, 150);
      } else if ($('#orderfinish').length) {
        var elements = [];

        $('#sort-rules tr:visible').each(function () {
          elements.push($(this).data('priority'));
        });
        $('#orderfinish').val(elements.toString().replace(/^,|,$/g, ''));
      }
    },
    axis: 'y',
    cursor: 'move',
    distance: 10,
    opacity: 0.8,
  });

  $('#sort-rules tbody').disableSelection();

  setTimeout(function () {
    // User Modal autocompletes
    $('input#site').attr('autocomplete', 'off');
    $('input#department').attr('autocomplete', 'off');
    $('input#UserFirstName').attr('autocomplete', 'off');
    $('input#UserLastName').attr('autocomplete', 'off');
    $('input#UserCallidNmbr').attr('autocomplete', 'off');
    $('input#UserCallidEmgr').attr('autocomplete', 'off');
    $('input#UserAreaCode').attr('autocomplete', 'off');

    // Domain modal autocompletes
    $('input#DomainDomain').attr('autocomplete', 'off');
    $('input#DomainEmailSender').attr('autocomplete', 'off');
    $('input#DomainAreaCode').attr('autocomplete', 'off');
    $('input#CdrScheduleScheduleName').attr('autocomplete', 'off');
  }, 200);

  addAutoCleanFunction();
}

// basic functions on document load
$(function () {
  var $body = $('body');

  $.ajaxSetup({ cache: false });

  log('running basic scripts.js functions');
  initFlashMessage(6000, 800);
  initContent();

  log('adding xhr abort click events');

  $body.on('click', '.nav-link', function () {
    if (typeof $.xhrPool !== 'undefined') {
      try {
        $.xhrPool.abortAll();
      } catch (e) {
        log(e);
      }
    }
  });

  $body.on('click', '.header-link', function () {
    if (typeof $.xhrPool !== 'undefined') {
      try {
        $.xhrPool.abortAll();
      } catch (e) {
        log(e);
      }
    }
  });

  log('adding print button listeners');

  $body
    .off('click.print')
    .on('click.print', '.print-div', function () {
      var divId = $(this).data('target');

      printDiv(divId);
    });

  log('adding print report button listeners');

  $body
    .off('click.print')
    .on('click.print', '.print-report', function () {
      printReport();
    });

  log('adding modal event listeners');

  $(document)
    .on('show.bs.modal', '.modal', function () {
      var $modal = $(this);

      log('modal "show" event triggered');

      window.openModalId = $modal[0].id;

      $('.helpsy').tooltip('hide');

      updateModalPosition();
    })
    .on('hidden.bs.modal', '.modal', function (e) {
      // make sure it's a modal show event
      if ($(e.target).hasClass('modal')) {
        log('modal "hidden" event triggered');

        window.openModalId = '';
      }
    });

  // checks placeholder compatibility with non-modern browsers
  // this checks to see if the browser supports placeholders
  var test = document.createElement('input');

  log('checking placeholder support');

  $.support.placeholder = 'placeholder' in test;

  // if the browser does not support placeholders, run this javascript alternative
  if (!$.support.placeholder) {
    log('placeholders not supported, using javascript alternative');

    var active = document.activeElement;

    $(':text').on('focus', function () {
      if ($(this).attr('placeholder') != '' && $(this).val() == $(this).attr('placeholder')) {
        $(this).val('')
          .removeClass('hasPlaceholder');
      }
    })
      .on('blur', function () {
        if ($(this).attr('placeholder') != ''
          && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder'))
        ) {
          $(this).val($(this).attr('placeholder'))
            .addClass('hasPlaceholder');
        }
      });

    $(':text').trigger('blur');
    $(active).trigger('focus');

    $('form').on('submit', function () {
      $(this).find('.hasPlaceholder')
        .each(function () {
          if ($(this).val() == $(this).attr('placeholder')) {
            $(this).val('');
          }
        });
    });
  }

  log('scripts.js: end document load functions');

  $body
    .on('change', '.fieldFilter', function () {
      $(this).next('.clearFilter')
        .css('visibility', $(this).val()
          .trim() ? 'visible' : 'hidden');
    })
    .on('click', '.clearFilter', function () {
      $(this).prev('select,input,textarea')
        .val('')
        .trigger('change');
    });

  $(document).on('click', '[data-toggle="modal"]', function (e) {
    var $this = $(this);

    if ($this.is('a')) {
      e.preventDefault();
    }
  });
});

$(document).on('click', '#logout', function () {
  localStorage.removeItem('openChats');
});

$(document).on('change', '.hasDatepicker', function () {
  if (this.value == '') {
    $('[id="' + this.id + '"]:hidden').val('');
  }
});

$(document).on('change', '.bulk-edit-checkbox', function () {
  var enableEdit = $(this).is(':checked');
  var inputFieldName = $(this).attr('name')
    .replace('-checkbox', '');
  var inputField = $('[name=\'' + inputFieldName + '\']');
  var val;

  if (enableEdit) {
    $('input[value="Save"]').prop('disabled', false);

    if (inputFieldName == 'data[Phonenumber][enable-date]'
      || inputFieldName == 'data[Phonenumber][disable-date]'
    ) {
      inputField.prop('disabled', false);
      inputField.siblings('.input-group-addon')[0].style.pointerEvents = 'auto';

      if ($('.bulk-edit-checkbox[name="data[Phonenumber][enable-date-checkbox]"]').is(':checked')
        && $('.bulk-edit-checkbox[name="data[Phonenumber][disable-date-checkbox]"]').is(':checked')
      ) {
        validateDateRange(inputField.data('date-format'));
      }
    } else if (inputFieldName == 'data[Phonenumber][enable]') {
      $('#enable').bootstrapSwitch('disabled', false);
    } else if (inputFieldName == 'data[Phonenumber][domain]') {
      inputField.prop('disabled', false);

      $('#PhonenumberApplication').prop('disabled', false);

      val = $('#PhonenumberApplication').val();

      $('#find-' + val)
        .animate({
          height: 'show',
          opacity: 'show',
        });
    } else {
      inputField.prop('disabled', false);
    }
  } else {
    if (inputFieldName == 'data[Phonenumber][enable-date]'
      || inputFieldName == 'data[Phonenumber][disable-date]'
    ) {
      $('#disable-date').validationEngine('hide');
      $('input[value="Save"]').prop('disabled', false);
      inputField.prop('disabled', true);
      inputField.siblings('.input-group-addon')[0].style.pointerEvents = 'none';
    } else if (inputFieldName == 'data[Phonenumber][enable]') {
      $('#enable').bootstrapSwitch('disabled', true);
    } else if (inputFieldName == 'data[Phonenumber][domain]') {
      inputField.prop('disabled', true);
      $('#PhonenumberApplication').prop('disabled', true);

      $('div[id^="find-"]:visible')
        .animate({
          height: 'hide',
          opacity: 'hide',
        });
    } else {
      inputField.prop('disabled', true);
    }

    if (!$('.bulk-edit-checkbox:checked').length) {
      $('input[value="Save"]').prop('disabled', true);
    }
  }
});

function toggleHiddenUserAddresses() {
    var uid = subUser.replace(/\./g, '_') + '-' + md5(subName);
    var cookieName = 'user-addresses-hidden-' + uid;

    if ($('#hideUserAddresses').is(':checked')) {
        Cookies.set(cookieName, 'true', { path: '/', expires: 7 });
    } else {
        Cookies.set(cookieName, 'false', { path: '/', expires: 7 });
    }

    location.reload();
}
